var _defs, _path, _path2, _path3, _path4, _g, _path5, _path6, _path7, _path8, _g2, _path9, _path10, _g3, _path11, _path12, _path13, _path14, _g4, _path15, _path16, _g5, _path17, _path18, _path19, _path20, _g6, _path21, _path22, _g7, _path23, _path24, _path25, _path26, _g8, _path27, _path28, _g9, _path29, _path30, _path31, _path32, _g10, _path33, _path34, _g11, _path35, _path36, _path37, _path38, _g12, _path39, _path40, _g13, _path41, _path42, _path43, _path44, _g14, _path45, _path46, _g15, _path47, _path48, _path49, _path50, _g16, _path51, _path52, _g17, _path53, _path54, _path55, _path56, _g18, _path57, _path58, _g19, _path59, _path60, _path61, _path62, _g20, _path63, _path64, _g21, _path65, _path66, _path67, _path68, _g22, _path69, _path70, _g23, _path71, _path72, _path73, _path74, _g24, _path75, _path76, _g25, _path77, _path78, _path79, _path80, _g26, _path81, _path82, _g27, _path83, _path84, _path85, _path86, _g28, _path87, _path88, _g29, _path89, _path90, _path91, _path92, _g30, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _g31, _path104, _path105, _path106, _path107, _g32, _g33, _g34, _g35;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReferImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 253,
    height: 282.65,
    viewBox: "0 0 253 282.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -8.108,
    y1: -23.183,
    x2: -7.617,
    y2: -23.183,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d17918"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -8.354,
    y1: -22.683,
    x2: -7.863,
    y2: -22.683,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -8.6,
    y1: -22.181,
    x2: -8.109,
    y2: -22.181,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -10.156,
    y1: -25.429,
    x2: -9.665,
    y2: -25.429,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -10.402,
    y1: -24.929,
    x2: -9.911,
    y2: -24.929,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -10.648,
    y1: -24.427,
    x2: -10.157,
    y2: -24.427,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -10.894,
    y1: -23.926,
    x2: -10.403,
    y2: -23.926,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -11.14,
    y1: -23.425,
    x2: -10.649,
    y2: -23.425,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -8.834,
    y1: -25.766,
    x2: -8.343,
    y2: -25.766,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: -9.08,
    y1: -25.265,
    x2: -8.589,
    y2: -25.265,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: -9.326,
    y1: -24.763,
    x2: -8.835,
    y2: -24.763,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: -9.572,
    y1: -24.262,
    x2: -9.081,
    y2: -24.262,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: -9.818,
    y1: -23.761,
    x2: -9.327,
    y2: -23.761,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 2.896,
    y1: -1.215,
    x2: 3.652,
    y2: -1.215,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: -25.181,
    y1: 6.025,
    x2: -24.426,
    y2: 6.025,
    xlinkHref: "#linear-gradient"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39792",
    "data-name": "Group 39792",
    transform: "translate(-747.184 -189.055)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39785",
    "data-name": "Group 39785",
    transform: "translate(747.184 189.055)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71898",
    "data-name": "Path 71898",
    d: "M914.063,485.265c0,9.135-37.358,16.54-83.439,16.54s-83.44-7.405-83.44-16.54,37.357-16.541,83.44-16.541S914.063,476.129,914.063,485.265Z",
    transform: "translate(-747.184 -256.483)",
    fill: "#ccc",
    opacity: 0.6,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_71899",
    "data-name": "Path 71899",
    d: "M983.977,384.238S969.4,310.391,914.564,277.754H875.377c-54.837,32.637-69.413,106.484-69.413,106.484-16.032,85.87,83.6,74.935,83.6,74.935h10.808S1000.01,470.108,983.977,384.238Z",
    transform: "translate(-760.935 -210.44)",
    fill: "#e8c47b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_71900",
    "data-name": "Path 71900",
    d: "M985.579,384.238S971,310.391,916.167,277.754H894.389c37.248,32.8,47.709,85.78,47.709,85.78,14.645,78.429-76.357,68.442-76.357,68.442H855.87s-23.729,2.6-45-5.3c18.309,39.285,80.3,32.494,80.3,32.494h10.808S1001.613,470.108,985.579,384.238Z",
    transform: "translate(-762.538 -210.44)",
    fill: "#dab873"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_71901",
    "data-name": "Path 71901",
    d: "M844.523,208.364c-2.031-2.674-5.243-8.428-1.756-11.094,4.544-3.475,13.461.208,18.087,1.5,6.048,1.688,12.737,3.2,19.382,2.506,6.486-.673,13.876-4.282,19.63-6.62,5.832-2.369,11.963-6.625,18.933-4.474,7.295,2.252,10.165,8.634,18.587,9.434,14.795,1.4,23.532-11.872,37.406-10.454,7.213.737,6.385,5.232,2.342,8.321l-53.649,58.887H884.3Z",
    transform: "translate(-769.856 -189.055)",
    fill: "#e8c47b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_39782",
    "data-name": "Group 39782",
    transform: "translate(86.69 147.63)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39781",
    "data-name": "Group 39781"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71902",
    "data-name": "Path 71902",
    d: "M978.9,538.194c-18.028,0-32.644-5.621-32.644-12.555s14.616-12.555,32.644-12.555,32.646,5.62,32.646,12.555S996.932,538.194,978.9,538.194Z",
    transform: "translate(-881.871 -414.808)",
    fill: "#ccc",
    opacity: 0.6,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71903",
    "data-name": "Path 71903",
    d: "M1024.045,487.8c-18.029,0-32.645-5.621-32.645-12.555s14.616-12.555,32.645-12.555,32.646,5.62,32.646,12.555S1042.075,487.8,1024.045,487.8Z",
    transform: "translate(-892.755 -402.657)",
    fill: "#ccc",
    opacity: 0.6,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71904",
    "data-name": "Path 71904",
    d: "M1018.654,528.354c-18.019-.609-32.817,4.514-33.051,11.444s14.184,13.04,32.2,13.65,32.815-4.514,33.05-11.444S1036.673,528.963,1018.654,528.354Z",
    transform: "translate(-891.357 -418.478)",
    fill: "#ccc",
    opacity: 0.6,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71905",
    "data-name": "Path 71905",
    d: "M897.292,501c18.019-.609,32.817,4.515,33.05,11.444s-14.183,13.041-32.2,13.651-32.815-4.515-33.05-11.444S879.273,501.6,897.292,501Z",
    transform: "translate(-862.301 -411.882)",
    fill: "#ccc",
    opacity: 0.6,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_39682",
    "data-name": "Group 39682",
    transform: "translate(20.641 74.327)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39681",
    "data-name": "Group 39681"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39680",
    "data-name": "Group 39680"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39679",
    "data-name": "Group 39679"
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_71906",
    "data-name": "Path 71906",
    d: "M888.614,504c0,6.933,14.616,12.555,32.645,12.555S953.9,510.933,953.9,504v-5.931h-65.29Z",
    transform: "translate(-888.614 -485.515)",
    fill: "#ff931e"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_39676",
    "data-name": "Group 39676",
    transform: "translate(0 12.579)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71907",
    "data-name": "Path 71907",
    d: "M927.537,502.086v15.378c1.023.037,2.058.058,3.106.058V502.086Z",
    transform: "translate(-897.998 -499.062)",
    fill: "#d17918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71908",
    "data-name": "Path 71908",
    d: "M919.243,502.086v14.906c1.687.2,3.43.337,5.22.426V502.086Z",
    transform: "translate(-895.999 -499.062)",
    fill: "#d17918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71909",
    "data-name": "Path 71909",
    d: "M910.566,515.869V498.1H888.614v5.906C888.614,509.5,897.79,514.166,910.566,515.869Z",
    transform: "translate(-888.614 -498.101)",
    fill: "#d17918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71910",
    "data-name": "Path 71910",
    d: "M946.954,502.086V516.7c.356-.052.713-.1,1.063-.161V502.086Z",
    transform: "translate(-902.68 -499.062)",
    fill: "#d17918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71911",
    "data-name": "Path 71911",
    d: "M941.6,517.18q.536-.048,1.062-.1v-14.99H941.6Z",
    transform: "translate(-901.389 -499.062)",
    fill: "#d17918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71912",
    "data-name": "Path 71912",
    d: "M934.818,502.086v15.4c.522-.015,1.038-.033,1.553-.058V502.086Z",
    transform: "translate(-899.754 -499.062)",
    fill: "#d17918"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39678",
    "data-name": "Group 39678"
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_71913",
    "data-name": "Path 71913",
    d: "M921.259,506.636c-18.028,0-32.645-5.621-32.645-12.555s14.616-12.555,32.645-12.555,32.646,5.621,32.646,12.555S939.288,506.636,921.259,506.636Z",
    transform: "translate(-888.614 -481.526)",
    fill: "#ff931e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_71914",
    "data-name": "Path 71914",
    d: "M939.652,504.468c-.926.03-1.859.049-2.807.049-18.029,0-32.645-5.62-32.645-12.554,0-4.309,5.649-8.11,14.251-10.372-16.713.547-29.837,5.935-29.837,12.505,0,6.934,14.616,12.555,32.645,12.555A73.684,73.684,0,0,0,939.652,504.468Z",
    transform: "translate(-888.614 -481.542)",
    opacity: 0.4,
    fill: "url(#linear-gradient)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_71915",
    "data-name": "Path 71915",
    d: "M953.887,494.719c-.537-6.754-14.93-12.167-32.62-12.167s-32.083,5.412-32.619,12.167c.537,6.751,14.93,12.164,32.619,12.164S953.35,501.47,953.887,494.719Zm-32.62,10.608c-14.653,0-26.573-4.585-26.573-10.219s11.92-10.219,26.573-10.219,26.573,4.584,26.573,10.219S935.919,505.327,921.267,505.327Z",
    transform: "translate(-888.622 -481.773)",
    fill: "#d17918"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_71916",
    "data-name": "Path 71916",
    d: "M923.719,495.773,911.093,499.4v2.522l12.922-3.984a13.126,13.126,0,0,0,5.491,2.331c.193.042.388.077.584.114v2.25h4.687V500.9c1.021.046,1.976.049,2.8.033v1.7h4.687v-6.752h-4.687v3.259c-.782.027-1.757.03-2.8-.037v-3.222H930.09v2.3a5.886,5.886,0,0,1-2.709-1.925Z",
    transform: "translate(-894.034 -484.961)",
    fill: "#d17918"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_71917",
    "data-name": "Path 71917",
    d: "M947.832,494.081c0,5.635-11.921,10.219-26.573,10.219s-26.573-4.585-26.573-10.219,11.92-10.219,26.573-10.219,26.573,4.585,26.573,10.219m6.073,0c0-6.933-14.616-12.555-32.646-12.555s-32.645,5.621-32.645,12.555,14.616,12.555,32.645,12.555,32.646-5.621,32.646-12.555Z",
    transform: "translate(-888.614 -481.526)",
    fill: "#ffc022"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_39677",
    "data-name": "Group 39677",
    transform: "translate(9.585 3.686)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71918",
    "data-name": "Path 71918",
    d: "M901.244,495.252c0-4.89,10.346-8.869,23.06-8.869s23.06,3.978,23.06,8.869-10.344,8.869-23.06,8.869S901.244,500.142,901.244,495.252Zm45.108,0c0-4.675-9.891-8.479-22.048-8.479s-22.047,3.8-22.047,8.479,9.891,8.48,22.047,8.48S946.352,499.927,946.352,495.252Z",
    transform: "translate(-901.244 -486.383)",
    fill: "#ffc022"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_71919",
    "data-name": "Path 71919",
    d: "M923.719,493.548l-12.626,3.631v2.52l12.922-3.986a13.116,13.116,0,0,0,5.491,2.331c.193.042.388.077.584.115v2.25h4.687V498.68c1.021.044,1.976.049,2.8.032v1.7h4.687v-6.753h-4.687v3.26c-.782.027-1.757.03-2.8-.038v-3.222H930.09v2.3a5.887,5.887,0,0,1-2.709-1.926Z",
    transform: "translate(-894.034 -484.425)",
    fill: "#ffc022"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39689",
    "data-name": "Group 39689",
    transform: "translate(20.641 61.772)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39688",
    "data-name": "Group 39688"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39687",
    "data-name": "Group 39687"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39686",
    "data-name": "Group 39686"
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_71920",
    "data-name": "Path 71920",
    d: "M888.614,487.457c0,6.933,14.616,12.554,32.645,12.554s32.646-5.622,32.646-12.554v-5.931h-65.29Z",
    transform: "translate(-888.614 -468.971)",
    fill: "#ff931e"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_39683",
    "data-name": "Group 39683",
    transform: "translate(0 12.579)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71921",
    "data-name": "Path 71921",
    d: "M927.537,485.543v15.378c1.023.037,2.058.058,3.106.058V485.543Z",
    transform: "translate(-897.998 -482.519)",
    fill: "#d17918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71922",
    "data-name": "Path 71922",
    d: "M919.243,485.543v14.9c1.687.2,3.43.338,5.22.426V485.543Z",
    transform: "translate(-895.999 -482.519)",
    fill: "#d17918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71923",
    "data-name": "Path 71923",
    d: "M910.566,499.326V481.558H888.614v5.906C888.614,492.957,897.79,497.622,910.566,499.326Z",
    transform: "translate(-888.614 -481.558)",
    fill: "#d17918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71924",
    "data-name": "Path 71924",
    d: "M946.954,485.543v14.613c.356-.052.713-.1,1.063-.161V485.543Z",
    transform: "translate(-902.68 -482.519)",
    fill: "#d17918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71925",
    "data-name": "Path 71925",
    d: "M941.6,500.637q.536-.048,1.062-.1v-14.99H941.6Z",
    transform: "translate(-901.389 -482.519)",
    fill: "#d17918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71926",
    "data-name": "Path 71926",
    d: "M934.818,485.543v15.4c.522-.014,1.038-.033,1.553-.058v-15.34Z",
    transform: "translate(-899.754 -482.519)",
    fill: "#d17918"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39685",
    "data-name": "Group 39685"
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_71927",
    "data-name": "Path 71927",
    d: "M921.259,490.092c-18.028,0-32.645-5.62-32.645-12.555s14.616-12.555,32.645-12.555S953.9,470.6,953.9,477.538,939.288,490.092,921.259,490.092Z",
    transform: "translate(-888.614 -464.983)",
    fill: "#ff931e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_71928",
    "data-name": "Path 71928",
    d: "M939.652,487.925c-.926.03-1.859.049-2.807.049-18.029,0-32.645-5.62-32.645-12.554,0-4.31,5.649-8.111,14.251-10.372-16.713.547-29.837,5.935-29.837,12.505,0,6.934,14.616,12.555,32.645,12.555A73.685,73.685,0,0,0,939.652,487.925Z",
    transform: "translate(-888.614 -464.999)",
    opacity: 0.4,
    fill: "url(#linear-gradient-2)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_71929",
    "data-name": "Path 71929",
    d: "M953.887,478.175c-.537-6.753-14.93-12.166-32.62-12.166s-32.083,5.412-32.619,12.166c.537,6.751,14.93,12.164,32.619,12.164S953.35,484.926,953.887,478.175Zm-32.62,10.609c-14.653,0-26.573-4.585-26.573-10.219s11.92-10.219,26.573-10.219,26.573,4.585,26.573,10.219S935.919,488.784,921.267,488.784Z",
    transform: "translate(-888.622 -465.23)",
    fill: "#d17918"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_71930",
    "data-name": "Path 71930",
    d: "M923.719,479.23l-12.626,3.629v2.522l12.922-3.983a13.156,13.156,0,0,0,5.491,2.33c.193.042.388.077.584.113v2.251h4.687v-1.73c1.021.045,1.976.049,2.8.033v1.7h4.687v-6.752h-4.687v3.26c-.782.027-1.757.028-2.8-.039v-3.222H930.09v2.3a5.882,5.882,0,0,1-2.709-1.926Z",
    transform: "translate(-894.034 -468.418)",
    fill: "#d17918"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_71931",
    "data-name": "Path 71931",
    d: "M947.832,477.538c0,5.635-11.921,10.219-26.573,10.219s-26.573-4.585-26.573-10.219,11.92-10.219,26.573-10.219,26.573,4.584,26.573,10.219m6.073,0c0-6.934-14.616-12.555-32.646-12.555s-32.645,5.62-32.645,12.555,14.616,12.555,32.645,12.555,32.646-5.62,32.646-12.555Z",
    transform: "translate(-888.614 -464.983)",
    fill: "#ffc022"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_39684",
    "data-name": "Group 39684",
    transform: "translate(9.585 3.686)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71932",
    "data-name": "Path 71932",
    d: "M901.244,478.709c0-4.891,10.346-8.869,23.06-8.869s23.06,3.977,23.06,8.869-10.344,8.869-23.06,8.869S901.244,483.6,901.244,478.709Zm45.108,0c0-4.676-9.891-8.48-22.048-8.48s-22.047,3.8-22.047,8.48,9.891,8.479,22.047,8.479S946.352,483.383,946.352,478.709Z",
    transform: "translate(-901.244 -469.84)",
    fill: "#ffc022"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_71933",
    "data-name": "Path 71933",
    d: "M923.719,477.005l-12.626,3.631v2.521l12.922-3.986a13.107,13.107,0,0,0,5.491,2.331c.193.042.388.077.584.115v2.249h4.687v-1.729c1.021.044,1.976.049,2.8.032v1.7h4.687v-6.753h-4.687v3.261c-.782.027-1.757.03-2.8-.039v-3.222H930.09v2.3a5.887,5.887,0,0,1-2.709-1.926Z",
    transform: "translate(-894.034 -467.882)",
    fill: "#ffc022"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39696",
    "data-name": "Group 39696",
    transform: "translate(20.641 49.218)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39695",
    "data-name": "Group 39695"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39694",
    "data-name": "Group 39694"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39693",
    "data-name": "Group 39693"
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_71934",
    "data-name": "Path 71934",
    d: "M888.614,470.914c0,6.933,14.616,12.554,32.645,12.554s32.646-5.621,32.646-12.554v-5.931h-65.29Z",
    transform: "translate(-888.614 -452.428)",
    fill: "#ff931e"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_39690",
    "data-name": "Group 39690",
    transform: "translate(0 12.579)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71935",
    "data-name": "Path 71935",
    d: "M927.537,469v15.378c1.023.036,2.058.058,3.106.058V469Z",
    transform: "translate(-897.998 -465.976)",
    fill: "#d17918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71936",
    "data-name": "Path 71936",
    d: "M919.243,469v14.9c1.687.2,3.43.338,5.22.426V469Z",
    transform: "translate(-895.999 -465.976)",
    fill: "#d17918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71937",
    "data-name": "Path 71937",
    d: "M910.566,482.782V465.015H888.614v5.907C888.614,476.414,897.79,481.079,910.566,482.782Z",
    transform: "translate(-888.614 -465.015)",
    fill: "#d17918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71938",
    "data-name": "Path 71938",
    d: "M946.954,469v14.613c.356-.052.713-.1,1.063-.159V469Z",
    transform: "translate(-902.68 -465.976)",
    fill: "#d17918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71939",
    "data-name": "Path 71939",
    d: "M941.6,484.094q.536-.049,1.062-.1V469H941.6Z",
    transform: "translate(-901.389 -465.976)",
    fill: "#d17918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71940",
    "data-name": "Path 71940",
    d: "M934.818,469v15.4c.522-.014,1.038-.033,1.553-.058V469Z",
    transform: "translate(-899.754 -465.976)",
    fill: "#d17918"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39692",
    "data-name": "Group 39692"
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_71941",
    "data-name": "Path 71941",
    d: "M921.259,473.549c-18.028,0-32.645-5.62-32.645-12.555s14.616-12.554,32.645-12.554,32.646,5.62,32.646,12.554S939.288,473.549,921.259,473.549Z",
    transform: "translate(-888.614 -448.44)",
    fill: "#ff931e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_71942",
    "data-name": "Path 71942",
    d: "M939.652,471.382c-.926.03-1.859.049-2.807.049-18.029,0-32.645-5.62-32.645-12.554,0-4.31,5.649-8.111,14.251-10.373-16.713.547-29.837,5.936-29.837,12.506,0,6.934,14.616,12.555,32.645,12.555A73.685,73.685,0,0,0,939.652,471.382Z",
    transform: "translate(-888.614 -448.455)",
    opacity: 0.4,
    fill: "url(#linear-gradient-3)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_71943",
    "data-name": "Path 71943",
    d: "M953.887,461.632c-.537-6.753-14.93-12.167-32.62-12.167s-32.083,5.413-32.619,12.167c.537,6.751,14.93,12.164,32.619,12.164S953.35,468.383,953.887,461.632Zm-32.62,10.608c-14.653,0-26.573-4.585-26.573-10.219s11.92-10.219,26.573-10.219,26.573,4.584,26.573,10.219S935.919,472.24,921.267,472.24Z",
    transform: "translate(-888.622 -448.687)",
    fill: "#d17918"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_71944",
    "data-name": "Path 71944",
    d: "M923.719,462.687l-12.626,3.628v2.523l12.922-3.983a13.156,13.156,0,0,0,5.491,2.33c.193.043.388.077.584.113v2.25h4.687v-1.729c1.021.045,1.976.049,2.8.032v1.7h4.687V462.8h-4.687v3.259c-.782.027-1.757.029-2.8-.038V462.8H930.09v2.3a5.887,5.887,0,0,1-2.709-1.926Z",
    transform: "translate(-894.034 -451.875)",
    fill: "#d17918"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_71945",
    "data-name": "Path 71945",
    d: "M947.832,460.995c0,5.635-11.921,10.219-26.573,10.219s-26.573-4.585-26.573-10.219,11.92-10.219,26.573-10.219,26.573,4.584,26.573,10.219m6.073,0c0-6.934-14.616-12.554-32.646-12.554s-32.645,5.62-32.645,12.554,14.616,12.555,32.645,12.555,32.646-5.62,32.646-12.555Z",
    transform: "translate(-888.614 -448.44)",
    fill: "#ffc022"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_39691",
    "data-name": "Group 39691",
    transform: "translate(9.585 3.685)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71946",
    "data-name": "Path 71946",
    d: "M901.244,462.165c0-4.891,10.346-8.869,23.06-8.869s23.06,3.978,23.06,8.869-10.344,8.869-23.06,8.869S901.244,467.055,901.244,462.165Zm45.108,0c0-4.676-9.891-8.48-22.048-8.48s-22.047,3.8-22.047,8.48,9.891,8.479,22.047,8.479S946.352,466.84,946.352,462.165Z",
    transform: "translate(-901.244 -453.296)",
    fill: "#ffc022"
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_71947",
    "data-name": "Path 71947",
    d: "M923.719,460.462l-12.626,3.631v2.521l12.922-3.987a13.126,13.126,0,0,0,5.491,2.331c.193.042.388.077.584.115v2.249h4.687v-1.729c1.021.043,1.976.049,2.8.031v1.7h4.687V460.57h-4.687v3.261c-.782.027-1.757.03-2.8-.039V460.57H930.09v2.3a5.883,5.883,0,0,1-2.709-1.927Z",
    transform: "translate(-894.034 -451.339)",
    fill: "#ffc022"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39703",
    "data-name": "Group 39703",
    transform: "translate(101.019 50.218)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39702",
    "data-name": "Group 39702"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39701",
    "data-name": "Group 39701"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39700",
    "data-name": "Group 39700"
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_71948",
    "data-name": "Path 71948",
    d: "M994.528,472.233c0,6.933,14.616,12.554,32.645,12.554s32.646-5.621,32.646-12.554V466.3H994.528Z",
    transform: "translate(-994.528 -453.747)",
    fill: "#ff931e"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_39697",
    "data-name": "Group 39697",
    transform: "translate(0 12.58)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71949",
    "data-name": "Path 71949",
    d: "M1033.451,470.318V485.7c1.023.036,2.058.058,3.106.058V470.318Z",
    transform: "translate(-1003.912 -467.295)",
    fill: "#d17918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71950",
    "data-name": "Path 71950",
    d: "M1025.157,470.318v14.906c1.687.2,3.431.337,5.22.425V470.318Z",
    transform: "translate(-1001.913 -467.295)",
    fill: "#d17918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71951",
    "data-name": "Path 71951",
    d: "M1016.48,484.1V466.334H994.528v5.906C994.528,477.733,1003.7,482.4,1016.48,484.1Z",
    transform: "translate(-994.528 -466.334)",
    fill: "#d17918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71952",
    "data-name": "Path 71952",
    d: "M1052.868,470.318v14.614c.356-.053.713-.1,1.062-.161V470.318Z",
    transform: "translate(-1008.594 -467.295)",
    fill: "#d17918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71953",
    "data-name": "Path 71953",
    d: "M1047.515,485.413q.536-.048,1.063-.1V470.318h-1.062Z",
    transform: "translate(-1007.303 -467.295)",
    fill: "#d17918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71954",
    "data-name": "Path 71954",
    d: "M1040.732,470.318v15.4c.522-.015,1.038-.033,1.553-.057V470.318Z",
    transform: "translate(-1005.668 -467.295)",
    fill: "#d17918"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39699",
    "data-name": "Group 39699"
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_71955",
    "data-name": "Path 71955",
    d: "M1027.173,474.868c-18.028,0-32.645-5.621-32.645-12.555s14.616-12.555,32.645-12.555,32.646,5.622,32.646,12.555S1045.2,474.868,1027.173,474.868Z",
    transform: "translate(-994.528 -449.758)",
    fill: "#ff931e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_71956",
    "data-name": "Path 71956",
    d: "M1045.566,472.7c-.926.03-1.859.05-2.807.05-18.029,0-32.645-5.62-32.645-12.554,0-4.31,5.649-8.111,14.251-10.372-16.713.547-29.838,5.935-29.838,12.5,0,6.934,14.616,12.555,32.645,12.555A73.649,73.649,0,0,0,1045.566,472.7Z",
    transform: "translate(-994.528 -449.774)",
    opacity: 0.4,
    fill: "url(#linear-gradient-4)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_71957",
    "data-name": "Path 71957",
    d: "M1059.8,462.951c-.537-6.753-14.93-12.166-32.62-12.166S995.1,456.2,994.562,462.951c.536,6.751,14.93,12.164,32.619,12.164S1059.264,469.7,1059.8,462.951Zm-32.62,10.609c-14.653,0-26.573-4.585-26.573-10.219s11.92-10.219,26.573-10.219,26.573,4.584,26.573,10.219S1041.833,473.56,1027.181,473.56Z",
    transform: "translate(-994.536 -450.006)",
    fill: "#d17918"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_71958",
    "data-name": "Path 71958",
    d: "M1029.633,464.005l-12.626,3.63v2.522l12.923-3.984a13.128,13.128,0,0,0,5.49,2.33c.194.043.389.078.584.115v2.249h4.687v-1.73c1.022.046,1.976.05,2.8.033v1.7h4.687v-6.752h-4.687v3.26c-.782.027-1.757.029-2.8-.038v-3.222H1036v2.3a5.875,5.875,0,0,1-2.708-1.925Z",
    transform: "translate(-999.948 -453.193)",
    fill: "#d17918"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_71959",
    "data-name": "Path 71959",
    d: "M1053.746,462.313c0,5.635-11.921,10.219-26.573,10.219s-26.573-4.584-26.573-10.219,11.92-10.219,26.573-10.219,26.573,4.585,26.573,10.219m6.073,0c0-6.933-14.616-12.555-32.646-12.555s-32.645,5.622-32.645,12.555,14.616,12.555,32.645,12.555,32.646-5.621,32.646-12.555Z",
    transform: "translate(-994.528 -449.758)",
    fill: "#ffc022"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_39698",
    "data-name": "Group 39698",
    transform: "translate(9.585 3.687)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71960",
    "data-name": "Path 71960",
    d: "M1007.158,463.484c0-4.89,10.346-8.868,23.06-8.868s23.06,3.977,23.06,8.868-10.344,8.869-23.06,8.869S1007.158,468.375,1007.158,463.484Zm45.107,0c0-4.675-9.891-8.479-22.048-8.479s-22.047,3.8-22.047,8.479,9.891,8.48,22.047,8.48S1052.266,468.159,1052.266,463.484Z",
    transform: "translate(-1007.158 -454.616)",
    fill: "#ffc022"
  }))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_71961",
    "data-name": "Path 71961",
    d: "M1029.633,461.781l-12.626,3.631v2.52l12.923-3.986a13.119,13.119,0,0,0,5.49,2.331c.194.042.389.077.584.115v2.251h4.687v-1.73c1.022.043,1.976.048,2.8.032v1.7h4.687v-6.754h-4.687v3.26c-.782.027-1.757.03-2.8-.037v-3.223H1036v2.3a5.893,5.893,0,0,1-2.708-1.926Z",
    transform: "translate(-999.948 -452.657)",
    fill: "#ffc022"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39710",
    "data-name": "Group 39710",
    transform: "translate(101.019 37.663)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39709",
    "data-name": "Group 39709"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39708",
    "data-name": "Group 39708"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39707",
    "data-name": "Group 39707"
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_71962",
    "data-name": "Path 71962",
    d: "M994.528,455.69c0,6.933,14.616,12.555,32.645,12.555s32.646-5.622,32.646-12.555v-5.932H994.528Z",
    transform: "translate(-994.528 -437.203)",
    fill: "#ff931e"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_39704",
    "data-name": "Group 39704",
    transform: "translate(0 12.58)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71963",
    "data-name": "Path 71963",
    d: "M1033.451,453.775v15.379c1.023.036,2.058.058,3.106.058V453.775Z",
    transform: "translate(-1003.912 -450.752)",
    fill: "#d17918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71964",
    "data-name": "Path 71964",
    d: "M1025.157,453.775v14.906c1.687.2,3.431.338,5.22.426V453.775Z",
    transform: "translate(-1001.913 -450.752)",
    fill: "#d17918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71965",
    "data-name": "Path 71965",
    d: "M1016.48,467.559V449.791H994.528V455.7C994.528,461.189,1003.7,465.855,1016.48,467.559Z",
    transform: "translate(-994.528 -449.791)",
    fill: "#d17918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71966",
    "data-name": "Path 71966",
    d: "M1052.868,453.775v14.614c.356-.053.713-.1,1.062-.161V453.775Z",
    transform: "translate(-1008.594 -450.752)",
    fill: "#d17918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71967",
    "data-name": "Path 71967",
    d: "M1047.515,468.87q.536-.048,1.063-.1v-14.99h-1.062Z",
    transform: "translate(-1007.303 -450.752)",
    fill: "#d17918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71968",
    "data-name": "Path 71968",
    d: "M1040.732,453.775v15.4c.522-.014,1.038-.033,1.553-.057V453.775Z",
    transform: "translate(-1005.668 -450.752)",
    fill: "#d17918"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39706",
    "data-name": "Group 39706"
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_71969",
    "data-name": "Path 71969",
    d: "M1027.173,458.324c-18.028,0-32.645-5.62-32.645-12.555s14.616-12.555,32.645-12.555,32.646,5.621,32.646,12.555S1045.2,458.324,1027.173,458.324Z",
    transform: "translate(-994.528 -433.215)",
    fill: "#ff931e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_71970",
    "data-name": "Path 71970",
    d: "M1045.566,456.157c-.926.03-1.859.049-2.807.049-18.029,0-32.645-5.62-32.645-12.554,0-4.311,5.649-8.112,14.251-10.372-16.713.547-29.838,5.935-29.838,12.5,0,6.934,14.616,12.555,32.645,12.555A73.648,73.648,0,0,0,1045.566,456.157Z",
    transform: "translate(-994.528 -433.231)",
    opacity: 0.4,
    fill: "url(#linear-gradient-5)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path_71971",
    "data-name": "Path 71971",
    d: "M1059.8,446.407c-.537-6.753-14.93-12.165-32.62-12.165s-32.083,5.412-32.619,12.165c.536,6.752,14.93,12.164,32.619,12.164S1059.264,453.159,1059.8,446.407Zm-32.62,10.609c-14.653,0-26.573-4.585-26.573-10.219s11.92-10.219,26.573-10.219,26.573,4.584,26.573,10.219S1041.833,457.017,1027.181,457.017Z",
    transform: "translate(-994.536 -433.463)",
    fill: "#d17918"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Path_71972",
    "data-name": "Path 71972",
    d: "M1029.633,447.462l-12.626,3.63v2.521l12.923-3.983a13.148,13.148,0,0,0,5.49,2.33c.194.042.389.078.584.114v2.25h4.687v-1.73c1.022.046,1.976.05,2.8.033v1.7h4.687v-6.752h-4.687v3.26c-.782.027-1.757.028-2.8-.039v-3.222H1036v2.3a5.871,5.871,0,0,1-2.708-1.926Z",
    transform: "translate(-999.948 -436.65)",
    fill: "#d17918"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Path_71973",
    "data-name": "Path 71973",
    d: "M1053.746,445.77c0,5.635-11.921,10.219-26.573,10.219S1000.6,451.4,1000.6,445.77s11.92-10.219,26.573-10.219,26.573,4.584,26.573,10.219m6.073,0c0-6.933-14.616-12.555-32.646-12.555s-32.645,5.621-32.645,12.555,14.616,12.555,32.645,12.555,32.646-5.62,32.646-12.555Z",
    transform: "translate(-994.528 -433.215)",
    fill: "#ffc022"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_39705",
    "data-name": "Group 39705",
    transform: "translate(9.585 3.687)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71974",
    "data-name": "Path 71974",
    d: "M1007.158,446.941c0-4.891,10.346-8.868,23.06-8.868s23.06,3.977,23.06,8.868-10.344,8.869-23.06,8.869S1007.158,451.831,1007.158,446.941Zm45.107,0c0-4.676-9.891-8.479-22.048-8.479s-22.047,3.8-22.047,8.479,9.891,8.479,22.047,8.479S1052.266,451.616,1052.266,446.941Z",
    transform: "translate(-1007.158 -438.073)",
    fill: "#ffc022"
  }))), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Path_71975",
    "data-name": "Path 71975",
    d: "M1029.633,445.238l-12.626,3.63v2.521l12.923-3.986a13.11,13.11,0,0,0,5.49,2.332c.194.041.389.077.584.115v2.25h4.687V450.37c1.022.043,1.976.048,2.8.032v1.7h4.687v-6.754h-4.687v3.261c-.782.027-1.757.03-2.8-.038v-3.223H1036v2.3a5.893,5.893,0,0,1-2.708-1.926Z",
    transform: "translate(-999.948 -436.114)",
    fill: "#ffc022"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39717",
    "data-name": "Group 39717",
    transform: "translate(101.019 25.109)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39716",
    "data-name": "Group 39716"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39715",
    "data-name": "Group 39715"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39714",
    "data-name": "Group 39714"
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Path_71976",
    "data-name": "Path 71976",
    d: "M994.528,439.147c0,6.933,14.616,12.554,32.645,12.554s32.646-5.621,32.646-12.554v-5.932H994.528Z",
    transform: "translate(-994.528 -420.66)",
    fill: "#ff931e"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_39711",
    "data-name": "Group 39711",
    transform: "translate(0 12.58)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71977",
    "data-name": "Path 71977",
    d: "M1033.451,437.232v15.379c1.023.036,2.058.058,3.106.058V437.232Z",
    transform: "translate(-1003.912 -434.209)",
    fill: "#d17918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71978",
    "data-name": "Path 71978",
    d: "M1025.157,437.232v14.906c1.687.2,3.431.338,5.22.425V437.232Z",
    transform: "translate(-1001.913 -434.209)",
    fill: "#d17918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71979",
    "data-name": "Path 71979",
    d: "M1016.48,451.015V433.248H994.528v5.907C994.528,444.646,1003.7,449.312,1016.48,451.015Z",
    transform: "translate(-994.528 -433.248)",
    fill: "#d17918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71980",
    "data-name": "Path 71980",
    d: "M1052.868,437.232v14.613c.356-.052.713-.1,1.062-.16V437.232Z",
    transform: "translate(-1008.594 -434.209)",
    fill: "#d17918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71981",
    "data-name": "Path 71981",
    d: "M1047.515,452.327c.357-.033.711-.067,1.063-.1v-14.99h-1.062Z",
    transform: "translate(-1007.303 -434.209)",
    fill: "#d17918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71982",
    "data-name": "Path 71982",
    d: "M1040.732,437.232v15.4c.522-.014,1.038-.033,1.553-.057V437.232Z",
    transform: "translate(-1005.668 -434.209)",
    fill: "#d17918"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39713",
    "data-name": "Group 39713"
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Path_71983",
    "data-name": "Path 71983",
    d: "M1027.173,441.781c-18.028,0-32.645-5.62-32.645-12.555s14.616-12.554,32.645-12.554,32.646,5.621,32.646,12.554S1045.2,441.781,1027.173,441.781Z",
    transform: "translate(-994.528 -416.672)",
    fill: "#ff931e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_71984",
    "data-name": "Path 71984",
    d: "M1045.566,439.614c-.926.03-1.859.049-2.807.049-18.029,0-32.645-5.62-32.645-12.554,0-4.311,5.649-8.112,14.251-10.373-16.713.547-29.838,5.935-29.838,12.505,0,6.934,14.616,12.555,32.645,12.555A73.649,73.649,0,0,0,1045.566,439.614Z",
    transform: "translate(-994.528 -416.688)",
    opacity: 0.4,
    fill: "url(#linear-gradient-6)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Path_71985",
    "data-name": "Path 71985",
    d: "M1059.8,429.864c-.537-6.753-14.93-12.166-32.62-12.166s-32.083,5.413-32.619,12.166c.536,6.752,14.93,12.164,32.619,12.164S1059.264,436.616,1059.8,429.864Zm-32.62,10.609c-14.653,0-26.573-4.585-26.573-10.219s11.92-10.219,26.573-10.219,26.573,4.584,26.573,10.219S1041.833,440.473,1027.181,440.473Z",
    transform: "translate(-994.536 -416.919)",
    fill: "#d17918"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Path_71986",
    "data-name": "Path 71986",
    d: "M1029.633,430.92l-12.626,3.628v2.522l12.923-3.983a13.148,13.148,0,0,0,5.49,2.33c.194.043.389.078.584.114v2.25h4.687v-1.73c1.022.046,1.976.05,2.8.032v1.7h4.687v-6.752h-4.687v3.259c-.782.027-1.757.029-2.8-.038v-3.222H1036v2.3a5.876,5.876,0,0,1-2.708-1.926Z",
    transform: "translate(-999.948 -420.107)",
    fill: "#d17918"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Path_71987",
    "data-name": "Path 71987",
    d: "M1053.746,429.227c0,5.635-11.921,10.219-26.573,10.219s-26.573-4.585-26.573-10.219,11.92-10.219,26.573-10.219,26.573,4.584,26.573,10.219m6.073,0c0-6.933-14.616-12.554-32.646-12.554s-32.645,5.621-32.645,12.554,14.616,12.555,32.645,12.555,32.646-5.62,32.646-12.555Z",
    transform: "translate(-994.528 -416.672)",
    fill: "#ffc022"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Group_39712",
    "data-name": "Group 39712",
    transform: "translate(9.585 3.686)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71988",
    "data-name": "Path 71988",
    d: "M1007.158,430.4c0-4.891,10.346-8.868,23.06-8.868s23.06,3.977,23.06,8.868-10.344,8.869-23.06,8.869S1007.158,435.288,1007.158,430.4Zm45.107,0c0-4.676-9.891-8.479-22.048-8.479s-22.047,3.8-22.047,8.479,9.891,8.479,22.047,8.479S1052.266,435.073,1052.266,430.4Z",
    transform: "translate(-1007.158 -421.529)",
    fill: "#ffc022"
  }))), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Path_71989",
    "data-name": "Path 71989",
    d: "M1029.633,428.7l-12.626,3.63v2.521l12.923-3.987a13.128,13.128,0,0,0,5.49,2.332c.194.041.389.076.584.115v2.25h4.687v-1.729c1.022.042,1.976.048,2.8.031v1.7h4.687V428.8h-4.687v3.261c-.782.027-1.757.03-2.8-.038V428.8H1036v2.3a5.883,5.883,0,0,1-2.708-1.927Z",
    transform: "translate(-999.948 -419.571)",
    fill: "#ffc022"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39724",
    "data-name": "Group 39724",
    transform: "translate(101.019 12.554)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39723",
    "data-name": "Group 39723"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39722",
    "data-name": "Group 39722"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39721",
    "data-name": "Group 39721"
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Path_71990",
    "data-name": "Path 71990",
    d: "M994.528,422.6c0,6.933,14.616,12.554,32.645,12.554s32.646-5.621,32.646-12.554v-5.932H994.528Z",
    transform: "translate(-994.528 -404.117)",
    fill: "#ff931e"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Group_39718",
    "data-name": "Group 39718",
    transform: "translate(0 12.58)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71991",
    "data-name": "Path 71991",
    d: "M1033.451,420.688v15.379c1.023.037,2.058.058,3.106.058V420.688Z",
    transform: "translate(-1003.912 -417.665)",
    fill: "#d17918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71992",
    "data-name": "Path 71992",
    d: "M1025.157,420.688v14.906c1.687.2,3.431.337,5.22.425V420.688Z",
    transform: "translate(-1001.913 -417.665)",
    fill: "#d17918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71993",
    "data-name": "Path 71993",
    d: "M1016.48,434.472V416.7H994.528v5.907C994.528,428.1,1003.7,432.769,1016.48,434.472Z",
    transform: "translate(-994.528 -416.705)",
    fill: "#d17918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71994",
    "data-name": "Path 71994",
    d: "M1052.868,420.688V435.3c.356-.052.713-.1,1.062-.161V420.688Z",
    transform: "translate(-1008.594 -417.665)",
    fill: "#d17918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71995",
    "data-name": "Path 71995",
    d: "M1047.515,435.783q.536-.048,1.063-.1V420.688h-1.062Z",
    transform: "translate(-1007.303 -417.665)",
    fill: "#d17918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71996",
    "data-name": "Path 71996",
    d: "M1040.732,420.688v15.4c.522-.014,1.038-.033,1.553-.057V420.688Z",
    transform: "translate(-1005.668 -417.665)",
    fill: "#d17918"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39720",
    "data-name": "Group 39720"
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Path_71997",
    "data-name": "Path 71997",
    d: "M1027.173,425.238c-18.028,0-32.645-5.621-32.645-12.554s14.616-12.555,32.645-12.555,32.646,5.622,32.646,12.555S1045.2,425.238,1027.173,425.238Z",
    transform: "translate(-994.528 -400.128)",
    fill: "#ff931e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_71998",
    "data-name": "Path 71998",
    d: "M1045.566,423.07c-.926.03-1.859.05-2.807.05-18.029,0-32.645-5.62-32.645-12.554,0-4.31,5.649-8.111,14.251-10.372-16.713.547-29.838,5.935-29.838,12.505,0,6.933,14.616,12.554,32.645,12.554A73.649,73.649,0,0,0,1045.566,423.07Z",
    transform: "translate(-994.528 -400.144)",
    opacity: 0.4,
    fill: "url(#linear-gradient-7)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Path_71999",
    "data-name": "Path 71999",
    d: "M1059.8,413.321c-.537-6.753-14.93-12.166-32.62-12.166s-32.083,5.412-32.619,12.166c.536,6.752,14.93,12.164,32.619,12.164S1059.264,420.073,1059.8,413.321Zm-32.62,10.609c-14.653,0-26.573-4.585-26.573-10.219s11.92-10.219,26.573-10.219,26.573,4.584,26.573,10.219S1041.833,423.93,1027.181,423.93Z",
    transform: "translate(-994.536 -400.376)",
    fill: "#d17918"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Path_72000",
    "data-name": "Path 72000",
    d: "M1029.633,414.376l-12.626,3.629v2.522l12.923-3.984a13.128,13.128,0,0,0,5.49,2.33c.194.043.389.079.584.115v2.25h4.687v-1.73c1.022.046,1.976.049,2.8.032v1.7h4.687v-6.753h-4.687v3.26c-.782.027-1.757.029-2.8-.038v-3.222H1036v2.3a5.875,5.875,0,0,1-2.708-1.925Z",
    transform: "translate(-999.948 -403.563)",
    fill: "#d17918"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "Path_72001",
    "data-name": "Path 72001",
    d: "M1053.746,412.683c0,5.635-11.921,10.219-26.573,10.219s-26.573-4.585-26.573-10.219,11.92-10.219,26.573-10.219,26.573,4.584,26.573,10.219m6.073,0c0-6.933-14.616-12.555-32.646-12.555s-32.645,5.622-32.645,12.555,14.616,12.554,32.645,12.554,32.646-5.621,32.646-12.554Z",
    transform: "translate(-994.528 -400.128)",
    fill: "#ffc022"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Group_39719",
    "data-name": "Group 39719",
    transform: "translate(9.585 3.687)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72002",
    "data-name": "Path 72002",
    d: "M1007.158,413.855c0-4.891,10.346-8.869,23.06-8.869s23.06,3.977,23.06,8.869-10.344,8.868-23.06,8.868S1007.158,418.745,1007.158,413.855Zm45.107,0c0-4.676-9.891-8.479-22.048-8.479s-22.047,3.8-22.047,8.479,9.891,8.479,22.047,8.479S1052.266,418.53,1052.266,413.855Z",
    transform: "translate(-1007.158 -404.986)",
    fill: "#ffc022"
  }))), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "Path_72003",
    "data-name": "Path 72003",
    d: "M1029.633,412.151l-12.626,3.631V418.3l12.923-3.987a13.119,13.119,0,0,0,5.49,2.331c.194.042.389.077.584.115v2.251h4.687v-1.73c1.022.043,1.976.048,2.8.032v1.7h4.687V412.26h-4.687v3.259c-.782.027-1.757.03-2.8-.037V412.26H1036v2.3a5.888,5.888,0,0,1-2.708-1.927Z",
    transform: "translate(-999.948 -403.027)",
    fill: "#ffc022"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39731",
    "data-name": "Group 39731",
    transform: "translate(101.019)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39730",
    "data-name": "Group 39730"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39729",
    "data-name": "Group 39729"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39728",
    "data-name": "Group 39728"
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "Path_72004",
    "data-name": "Path 72004",
    d: "M994.528,406.06c0,6.933,14.616,12.555,32.645,12.555s32.646-5.622,32.646-12.555v-5.932H994.528Z",
    transform: "translate(-994.528 -387.574)",
    fill: "#ff931e"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Group_39725",
    "data-name": "Group 39725",
    transform: "translate(0 12.579)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72005",
    "data-name": "Path 72005",
    d: "M1033.451,404.145v15.379q1.534.056,3.106.058V404.145Z",
    transform: "translate(-1003.912 -401.122)",
    fill: "#d17918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72006",
    "data-name": "Path 72006",
    d: "M1025.157,404.145v14.906c1.687.2,3.431.337,5.22.425V404.145Z",
    transform: "translate(-1001.913 -401.122)",
    fill: "#d17918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72007",
    "data-name": "Path 72007",
    d: "M1016.48,417.929V400.161H994.528v5.907C994.528,411.56,1003.7,416.226,1016.48,417.929Z",
    transform: "translate(-994.528 -400.161)",
    fill: "#d17918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72008",
    "data-name": "Path 72008",
    d: "M1052.868,404.145v14.614c.356-.052.713-.1,1.062-.161V404.145Z",
    transform: "translate(-1008.594 -401.122)",
    fill: "#d17918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72009",
    "data-name": "Path 72009",
    d: "M1047.515,419.24q.536-.048,1.063-.1V404.145h-1.062Z",
    transform: "translate(-1007.303 -401.122)",
    fill: "#d17918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72010",
    "data-name": "Path 72010",
    d: "M1040.732,404.145v15.4c.522-.014,1.038-.033,1.553-.057V404.145Z",
    transform: "translate(-1005.668 -401.122)",
    fill: "#d17918"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39727",
    "data-name": "Group 39727"
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "Path_72011",
    "data-name": "Path 72011",
    d: "M1027.173,408.7c-18.028,0-32.645-5.621-32.645-12.555s14.616-12.554,32.645-12.554,32.646,5.62,32.646,12.554S1045.2,408.7,1027.173,408.7Z",
    transform: "translate(-994.528 -383.586)",
    fill: "#ff931e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_72012",
    "data-name": "Path 72012",
    d: "M1045.566,406.527c-.926.031-1.859.05-2.807.05-18.029,0-32.645-5.62-32.645-12.555,0-4.311,5.649-8.111,14.251-10.372-16.713.547-29.838,5.935-29.838,12.5,0,6.934,14.616,12.555,32.645,12.555A73.649,73.649,0,0,0,1045.566,406.527Z",
    transform: "translate(-994.528 -383.602)",
    opacity: 0.4,
    fill: "url(#linear-gradient-8)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "Path_72013",
    "data-name": "Path 72013",
    d: "M1059.8,396.777c-.537-6.753-14.93-12.165-32.62-12.165s-32.083,5.412-32.619,12.165c.536,6.752,14.93,12.165,32.619,12.165S1059.264,403.529,1059.8,396.777Zm-32.62,10.609c-14.653,0-26.573-4.585-26.573-10.219s11.92-10.219,26.573-10.219,26.573,4.584,26.573,10.219S1041.833,407.387,1027.181,407.387Z",
    transform: "translate(-994.536 -383.833)",
    fill: "#d17918"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "Path_72014",
    "data-name": "Path 72014",
    d: "M1029.633,397.833l-12.626,3.629v2.522L1029.93,400a13.129,13.129,0,0,0,5.49,2.33c.194.042.389.078.584.114v2.251h4.687v-1.73c1.022.046,1.976.05,2.8.033v1.7h4.687v-6.753h-4.687v3.26c-.782.027-1.757.028-2.8-.039v-3.222H1036v2.3a5.875,5.875,0,0,1-2.708-1.925Z",
    transform: "translate(-999.948 -387.021)",
    fill: "#d17918"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "Path_72015",
    "data-name": "Path 72015",
    d: "M1053.746,396.14c0,5.635-11.921,10.219-26.573,10.219s-26.573-4.585-26.573-10.219,11.92-10.219,26.573-10.219,26.573,4.584,26.573,10.219m6.073,0c0-6.933-14.616-12.554-32.646-12.554s-32.645,5.62-32.645,12.554,14.616,12.555,32.645,12.555,32.646-5.621,32.646-12.555Z",
    transform: "translate(-994.528 -383.586)",
    fill: "#ffc022"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Group_39726",
    "data-name": "Group 39726",
    transform: "translate(9.585 3.686)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72016",
    "data-name": "Path 72016",
    d: "M1007.158,397.311c0-4.89,10.346-8.868,23.06-8.868s23.06,3.977,23.06,8.868-10.344,8.869-23.06,8.869S1007.158,402.2,1007.158,397.311Zm45.107,0c0-4.676-9.891-8.479-22.048-8.479s-22.047,3.8-22.047,8.479,9.891,8.479,22.047,8.479S1052.266,401.986,1052.266,397.311Z",
    transform: "translate(-1007.158 -388.443)",
    fill: "#ffc022"
  }))), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "Path_72017",
    "data-name": "Path 72017",
    d: "M1029.633,395.608l-12.626,3.63v2.521l12.923-3.986a13.119,13.119,0,0,0,5.49,2.331c.194.041.389.077.584.115v2.251h4.687v-1.73c1.022.043,1.976.048,2.8.032v1.7h4.687v-6.754h-4.687v3.26c-.782.027-1.757.03-2.8-.037v-3.223H1036v2.3a5.887,5.887,0,0,1-2.708-1.926Z",
    transform: "translate(-999.948 -386.484)",
    fill: "#ffc022"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39738",
    "data-name": "Group 39738",
    transform: "translate(71.513 88.159)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39737",
    "data-name": "Group 39737"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39736",
    "data-name": "Group 39736"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39735",
    "data-name": "Group 39735"
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "Path_72018",
    "data-name": "Path 72018",
    d: "M955.648,522.227c0,6.933,14.616,12.554,32.645,12.554s32.646-5.621,32.646-12.554v-5.932H955.648Z",
    transform: "translate(-955.648 -503.741)",
    fill: "#ff931e"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Group_39732",
    "data-name": "Group 39732",
    transform: "translate(0 12.579)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72019",
    "data-name": "Path 72019",
    d: "M994.571,520.312v15.379c1.023.037,2.058.058,3.106.058V520.312Z",
    transform: "translate(-965.032 -517.289)",
    fill: "#d17918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72020",
    "data-name": "Path 72020",
    d: "M986.277,520.312v14.906c1.687.2,3.431.337,5.22.425V520.312Z",
    transform: "translate(-963.033 -517.289)",
    fill: "#d17918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72021",
    "data-name": "Path 72021",
    d: "M977.6,534.1V516.328H955.648v5.907C955.648,527.727,964.824,532.393,977.6,534.1Z",
    transform: "translate(-955.648 -516.328)",
    fill: "#d17918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72022",
    "data-name": "Path 72022",
    d: "M1013.988,520.312v14.614c.356-.052.713-.1,1.063-.161V520.312Z",
    transform: "translate(-969.714 -517.289)",
    fill: "#d17918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72023",
    "data-name": "Path 72023",
    d: "M1008.636,535.407q.535-.048,1.062-.1V520.312h-1.062Z",
    transform: "translate(-968.423 -517.289)",
    fill: "#d17918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72024",
    "data-name": "Path 72024",
    d: "M1001.852,520.312v15.4c.522-.014,1.039-.033,1.553-.057V520.312Z",
    transform: "translate(-966.788 -517.289)",
    fill: "#d17918"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39734",
    "data-name": "Group 39734"
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "Path_72025",
    "data-name": "Path 72025",
    d: "M988.293,524.862c-18.028,0-32.645-5.621-32.645-12.555s14.616-12.554,32.645-12.554,32.646,5.621,32.646,12.554S1006.323,524.862,988.293,524.862Z",
    transform: "translate(-955.648 -499.753)",
    fill: "#ff931e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_72026",
    "data-name": "Path 72026",
    d: "M1006.686,522.694c-.926.031-1.859.05-2.807.05-18.029,0-32.645-5.62-32.645-12.555,0-4.31,5.649-8.111,14.251-10.372-16.713.547-29.838,5.935-29.838,12.5,0,6.934,14.616,12.555,32.645,12.555A73.646,73.646,0,0,0,1006.686,522.694Z",
    transform: "translate(-955.648 -499.769)",
    opacity: 0.4,
    fill: "url(#linear-gradient-9)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "Path_72027",
    "data-name": "Path 72027",
    d: "M1020.921,512.945c-.537-6.753-14.93-12.166-32.62-12.166s-32.083,5.412-32.619,12.166c.536,6.752,14.93,12.164,32.619,12.164S1020.384,519.7,1020.921,512.945ZM988.3,523.554c-14.653,0-26.573-4.585-26.573-10.219s11.92-10.219,26.573-10.219,26.573,4.584,26.573,10.219S1002.953,523.554,988.3,523.554Z",
    transform: "translate(-955.656 -500)",
    fill: "#d17918"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "Path_72028",
    "data-name": "Path 72028",
    d: "M990.753,514l-12.626,3.629v2.522l12.923-3.984a13.134,13.134,0,0,0,5.491,2.33c.194.042.389.078.584.115v2.25h4.687v-1.73c1.021.046,1.976.05,2.8.033v1.7h4.687v-6.753h-4.687v3.26c-.782.026-1.757.029-2.8-.038v-3.222h-4.687v2.3a5.873,5.873,0,0,1-2.708-1.925Z",
    transform: "translate(-961.068 -503.188)",
    fill: "#d17918"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "Path_72029",
    "data-name": "Path 72029",
    d: "M1014.866,512.307c0,5.635-11.921,10.219-26.573,10.219s-26.573-4.585-26.573-10.219,11.92-10.219,26.573-10.219,26.573,4.585,26.573,10.219m6.073,0c0-6.933-14.616-12.554-32.646-12.554s-32.645,5.621-32.645,12.554,14.616,12.555,32.645,12.555,32.646-5.621,32.646-12.555Z",
    transform: "translate(-955.648 -499.753)",
    fill: "#ffc022"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Group_39733",
    "data-name": "Group 39733",
    transform: "translate(9.585 3.686)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72030",
    "data-name": "Path 72030",
    d: "M968.278,513.478c0-4.89,10.346-8.868,23.06-8.868s23.061,3.977,23.061,8.868-10.345,8.869-23.061,8.869S968.278,518.369,968.278,513.478Zm45.108,0c0-4.675-9.892-8.478-22.048-8.478s-22.048,3.8-22.048,8.478,9.891,8.48,22.048,8.48S1013.386,518.154,1013.386,513.478Z",
    transform: "translate(-968.278 -504.61)",
    fill: "#ffc022"
  }))), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "Path_72031",
    "data-name": "Path 72031",
    d: "M990.753,511.775l-12.626,3.631v2.52l12.923-3.986a13.124,13.124,0,0,0,5.491,2.331c.194.042.389.077.584.115v2.251h4.687v-1.73c1.021.043,1.976.048,2.8.032v1.7h4.687v-6.753h-4.687v3.259c-.782.027-1.757.03-2.8-.037v-3.222h-4.687v2.3a5.886,5.886,0,0,1-2.708-1.926Z",
    transform: "translate(-961.068 -502.652)",
    fill: "#ffc022"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39745",
    "data-name": "Group 39745",
    transform: "translate(71.513 75.605)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39744",
    "data-name": "Group 39744"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39743",
    "data-name": "Group 39743"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39742",
    "data-name": "Group 39742"
  }, _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    id: "Path_72032",
    "data-name": "Path 72032",
    d: "M955.648,505.684c0,6.933,14.616,12.555,32.645,12.555s32.646-5.622,32.646-12.555v-5.931H955.648Z",
    transform: "translate(-955.648 -487.199)",
    fill: "#ff931e"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "Group_39739",
    "data-name": "Group 39739",
    transform: "translate(0 12.579)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72033",
    "data-name": "Path 72033",
    d: "M994.571,503.769v15.379c1.023.037,2.058.058,3.106.058V503.769Z",
    transform: "translate(-965.032 -500.746)",
    fill: "#d17918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72034",
    "data-name": "Path 72034",
    d: "M986.277,503.769v14.906c1.687.2,3.431.338,5.22.426V503.769Z",
    transform: "translate(-963.033 -500.746)",
    fill: "#d17918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72035",
    "data-name": "Path 72035",
    d: "M977.6,517.553V499.785H955.648v5.906C955.648,511.183,964.824,515.849,977.6,517.553Z",
    transform: "translate(-955.648 -499.785)",
    fill: "#d17918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72036",
    "data-name": "Path 72036",
    d: "M1013.988,503.769v14.614c.356-.052.713-.1,1.063-.161V503.769Z",
    transform: "translate(-969.714 -500.746)",
    fill: "#d17918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72037",
    "data-name": "Path 72037",
    d: "M1008.636,518.864q.535-.048,1.062-.1v-14.99h-1.062Z",
    transform: "translate(-968.423 -500.746)",
    fill: "#d17918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72038",
    "data-name": "Path 72038",
    d: "M1001.852,503.769v15.4c.522-.014,1.039-.033,1.553-.057V503.769Z",
    transform: "translate(-966.788 -500.746)",
    fill: "#d17918"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39741",
    "data-name": "Group 39741"
  }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    id: "Path_72039",
    "data-name": "Path 72039",
    d: "M988.293,508.318c-18.028,0-32.645-5.62-32.645-12.554s14.616-12.555,32.645-12.555,32.646,5.62,32.646,12.555S1006.323,508.318,988.293,508.318Z",
    transform: "translate(-955.648 -483.21)",
    fill: "#ff931e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_72040",
    "data-name": "Path 72040",
    d: "M1006.686,506.152c-.926.03-1.859.049-2.807.049-18.029,0-32.645-5.62-32.645-12.554,0-4.311,5.649-8.112,14.251-10.372-16.713.547-29.838,5.935-29.838,12.505,0,6.933,14.616,12.554,32.645,12.554A73.69,73.69,0,0,0,1006.686,506.152Z",
    transform: "translate(-955.648 -483.226)",
    opacity: 0.4,
    fill: "url(#linear-gradient-10)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    id: "Path_72041",
    "data-name": "Path 72041",
    d: "M1020.921,496.4c-.537-6.753-14.93-12.165-32.62-12.165s-32.083,5.413-32.619,12.165c.536,6.752,14.93,12.164,32.619,12.164S1020.384,503.153,1020.921,496.4ZM988.3,507.011c-14.653,0-26.573-4.585-26.573-10.219s11.92-10.219,26.573-10.219,26.573,4.584,26.573,10.219S1002.953,507.011,988.3,507.011Z",
    transform: "translate(-955.656 -483.457)",
    fill: "#d17918"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    id: "Path_72042",
    "data-name": "Path 72042",
    d: "M990.753,497.457l-12.626,3.629v2.521l12.923-3.983a13.153,13.153,0,0,0,5.491,2.33c.194.043.389.078.584.114v2.251h4.687v-1.73c1.021.046,1.976.05,2.8.033v1.7h4.687v-6.753h-4.687v3.26c-.782.027-1.757.028-2.8-.039v-3.222h-4.687v2.3a5.869,5.869,0,0,1-2.708-1.926Z",
    transform: "translate(-961.068 -486.645)",
    fill: "#d17918"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    id: "Path_72043",
    "data-name": "Path 72043",
    d: "M1014.866,495.765c0,5.634-11.921,10.219-26.573,10.219S961.72,501.4,961.72,495.765s11.92-10.219,26.573-10.219,26.573,4.584,26.573,10.219m6.073,0c0-6.934-14.616-12.555-32.646-12.555s-32.645,5.62-32.645,12.555,14.616,12.554,32.645,12.554,32.646-5.62,32.646-12.554Z",
    transform: "translate(-955.648 -483.21)",
    fill: "#ffc022"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "Group_39740",
    "data-name": "Group 39740",
    transform: "translate(9.585 3.686)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72044",
    "data-name": "Path 72044",
    d: "M968.278,496.936c0-4.892,10.346-8.869,23.06-8.869s23.061,3.977,23.061,8.869-10.345,8.868-23.061,8.868S968.278,501.825,968.278,496.936Zm45.108,0c0-4.676-9.892-8.48-22.048-8.48s-22.048,3.8-22.048,8.48,9.891,8.478,22.048,8.478S1013.386,501.61,1013.386,496.936Z",
    transform: "translate(-968.278 -488.067)",
    fill: "#ffc022"
  }))), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    id: "Path_72045",
    "data-name": "Path 72045",
    d: "M990.753,495.232l-12.626,3.63v2.521L991.05,497.4a13.124,13.124,0,0,0,5.491,2.331c.194.041.389.077.584.115v2.25h4.687v-1.729c1.021.043,1.976.048,2.8.032v1.7h4.687V495.34h-4.687v3.26c-.782.027-1.757.03-2.8-.038V495.34h-4.687v2.3a5.886,5.886,0,0,1-2.708-1.926Z",
    transform: "translate(-961.068 -486.108)",
    fill: "#ffc022"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39752",
    "data-name": "Group 39752",
    transform: "translate(71.513 63.05)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39751",
    "data-name": "Group 39751"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39750",
    "data-name": "Group 39750"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39749",
    "data-name": "Group 39749"
  }, _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    id: "Path_72046",
    "data-name": "Path 72046",
    d: "M955.648,489.141c0,6.933,14.616,12.554,32.645,12.554s32.646-5.621,32.646-12.554V483.21H955.648Z",
    transform: "translate(-955.648 -470.656)",
    fill: "#ff931e"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "Group_39746",
    "data-name": "Group 39746",
    transform: "translate(0 12.579)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72047",
    "data-name": "Path 72047",
    d: "M994.571,487.226v15.379c1.023.036,2.058.058,3.106.058V487.226Z",
    transform: "translate(-965.032 -484.203)",
    fill: "#d17918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72048",
    "data-name": "Path 72048",
    d: "M986.277,487.226v14.906c1.687.2,3.431.338,5.22.425V487.226Z",
    transform: "translate(-963.033 -484.203)",
    fill: "#d17918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72049",
    "data-name": "Path 72049",
    d: "M977.6,501.009V483.242H955.648v5.907C955.648,494.64,964.824,499.306,977.6,501.009Z",
    transform: "translate(-955.648 -483.242)",
    fill: "#d17918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72050",
    "data-name": "Path 72050",
    d: "M1013.988,487.226v14.613c.356-.052.713-.1,1.063-.16V487.226Z",
    transform: "translate(-969.714 -484.203)",
    fill: "#d17918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72051",
    "data-name": "Path 72051",
    d: "M1008.636,502.321c.357-.033.71-.067,1.062-.1v-14.99h-1.062Z",
    transform: "translate(-968.423 -484.203)",
    fill: "#d17918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72052",
    "data-name": "Path 72052",
    d: "M1001.852,487.226v15.4c.522-.014,1.039-.033,1.553-.057V487.226Z",
    transform: "translate(-966.788 -484.203)",
    fill: "#d17918"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39748",
    "data-name": "Group 39748"
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    id: "Path_72053",
    "data-name": "Path 72053",
    d: "M988.293,491.776c-18.028,0-32.645-5.621-32.645-12.555s14.616-12.555,32.645-12.555,32.646,5.62,32.646,12.555S1006.323,491.776,988.293,491.776Z",
    transform: "translate(-955.648 -466.667)",
    fill: "#ff931e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_72054",
    "data-name": "Path 72054",
    d: "M1006.686,489.609c-.926.03-1.859.049-2.807.049-18.029,0-32.645-5.62-32.645-12.554,0-4.311,5.649-8.111,14.251-10.373-16.713.547-29.838,5.935-29.838,12.506,0,6.933,14.616,12.555,32.645,12.555A73.686,73.686,0,0,0,1006.686,489.609Z",
    transform: "translate(-955.648 -466.682)",
    opacity: 0.4,
    fill: "url(#linear-gradient-11)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    id: "Path_72055",
    "data-name": "Path 72055",
    d: "M1020.921,479.858c-.537-6.753-14.93-12.166-32.62-12.166s-32.083,5.413-32.619,12.166c.536,6.752,14.93,12.165,32.619,12.165S1020.384,486.61,1020.921,479.858ZM988.3,490.467c-14.653,0-26.573-4.585-26.573-10.219s11.92-10.219,26.573-10.219,26.573,4.585,26.573,10.219S1002.953,490.467,988.3,490.467Z",
    transform: "translate(-955.656 -466.914)",
    fill: "#d17918"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    id: "Path_72056",
    "data-name": "Path 72056",
    d: "M990.753,480.914l-12.626,3.628v2.522l12.923-3.983a13.154,13.154,0,0,0,5.491,2.33c.194.042.389.078.584.114v2.25h4.687v-1.73c1.021.046,1.976.05,2.8.032v1.7h4.687v-6.752h-4.687v3.259c-.782.027-1.757.029-2.8-.038v-3.222h-4.687v2.3a5.875,5.875,0,0,1-2.708-1.926Z",
    transform: "translate(-961.068 -470.102)",
    fill: "#d17918"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    id: "Path_72057",
    "data-name": "Path 72057",
    d: "M1014.866,479.221c0,5.634-11.921,10.219-26.573,10.219s-26.573-4.585-26.573-10.219S973.64,469,988.293,469s26.573,4.584,26.573,10.219m6.073,0c0-6.934-14.616-12.555-32.646-12.555s-32.645,5.62-32.645,12.555,14.616,12.555,32.645,12.555,32.646-5.621,32.646-12.555Z",
    transform: "translate(-955.648 -466.667)",
    fill: "#ffc022"
  })), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "Group_39747",
    "data-name": "Group 39747",
    transform: "translate(9.585 3.685)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72058",
    "data-name": "Path 72058",
    d: "M968.278,480.392c0-4.892,10.346-8.869,23.06-8.869s23.061,3.977,23.061,8.869-10.345,8.868-23.061,8.868S968.278,485.282,968.278,480.392Zm45.108,0c0-4.676-9.892-8.48-22.048-8.48s-22.048,3.8-22.048,8.48,9.891,8.478,22.048,8.478S1013.386,485.067,1013.386,480.392Z",
    transform: "translate(-968.278 -471.523)",
    fill: "#ffc022"
  }))), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    id: "Path_72059",
    "data-name": "Path 72059",
    d: "M990.753,478.689l-12.626,3.63v2.522l12.923-3.987a13.144,13.144,0,0,0,5.491,2.331c.194.042.389.076.584.115v2.25h4.687v-1.729c1.021.043,1.976.048,2.8.031v1.7h4.687V478.8h-4.687v3.261c-.782.027-1.757.03-2.8-.039V478.8h-4.687v2.3a5.881,5.881,0,0,1-2.708-1.927Z",
    transform: "translate(-961.068 -469.565)",
    fill: "#ffc022"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39759",
    "data-name": "Group 39759",
    transform: "translate(71.513 50.495)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39758",
    "data-name": "Group 39758"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39757",
    "data-name": "Group 39757"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39756",
    "data-name": "Group 39756"
  }, _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    id: "Path_72060",
    "data-name": "Path 72060",
    d: "M955.648,472.6c0,6.933,14.616,12.554,32.645,12.554s32.646-5.621,32.646-12.554v-5.931H955.648Z",
    transform: "translate(-955.648 -454.112)",
    fill: "#ff931e"
  })), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "Group_39753",
    "data-name": "Group 39753",
    transform: "translate(0 12.58)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72061",
    "data-name": "Path 72061",
    d: "M994.571,470.682v15.379c1.023.037,2.058.058,3.106.058V470.682Z",
    transform: "translate(-965.032 -467.659)",
    fill: "#d17918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72062",
    "data-name": "Path 72062",
    d: "M986.277,470.682v14.906c1.687.2,3.431.337,5.22.425V470.682Z",
    transform: "translate(-963.033 -467.659)",
    fill: "#d17918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72063",
    "data-name": "Path 72063",
    d: "M977.6,484.466V466.7H955.648v5.907C955.648,478.1,964.824,482.763,977.6,484.466Z",
    transform: "translate(-955.648 -466.699)",
    fill: "#d17918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72064",
    "data-name": "Path 72064",
    d: "M1013.988,470.682V485.3c.356-.052.713-.1,1.063-.161V470.682Z",
    transform: "translate(-969.714 -467.659)",
    fill: "#d17918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72065",
    "data-name": "Path 72065",
    d: "M1008.636,485.777q.535-.048,1.062-.1V470.682h-1.062Z",
    transform: "translate(-968.423 -467.659)",
    fill: "#d17918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72066",
    "data-name": "Path 72066",
    d: "M1001.852,470.682v15.4c.522-.014,1.039-.033,1.553-.057V470.682Z",
    transform: "translate(-966.788 -467.659)",
    fill: "#d17918"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39755",
    "data-name": "Group 39755"
  }, _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    id: "Path_72067",
    "data-name": "Path 72067",
    d: "M988.293,475.233c-18.028,0-32.645-5.622-32.645-12.555s14.616-12.555,32.645-12.555,32.646,5.621,32.646,12.555S1006.323,475.233,988.293,475.233Z",
    transform: "translate(-955.648 -450.123)",
    fill: "#ff931e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_72068",
    "data-name": "Path 72068",
    d: "M1006.686,473.065c-.926.03-1.859.049-2.807.049-18.029,0-32.645-5.62-32.645-12.554,0-4.31,5.649-8.11,14.251-10.372-16.713.547-29.838,5.935-29.838,12.506,0,6.933,14.616,12.555,32.645,12.555A73.683,73.683,0,0,0,1006.686,473.065Z",
    transform: "translate(-955.648 -450.139)",
    opacity: 0.4,
    fill: "url(#linear-gradient-12)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    id: "Path_72069",
    "data-name": "Path 72069",
    d: "M1020.921,463.315c-.537-6.753-14.93-12.166-32.62-12.166s-32.083,5.412-32.619,12.166c.536,6.752,14.93,12.165,32.619,12.165S1020.384,470.067,1020.921,463.315ZM988.3,473.924c-14.653,0-26.573-4.585-26.573-10.219s11.92-10.219,26.573-10.219,26.573,4.584,26.573,10.219S1002.953,473.924,988.3,473.924Z",
    transform: "translate(-955.656 -450.37)",
    fill: "#d17918"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    id: "Path_72070",
    "data-name": "Path 72070",
    d: "M990.753,464.37,978.127,468v2.522l12.923-3.984a13.134,13.134,0,0,0,5.491,2.33c.194.042.389.079.584.115v2.25h4.687V469.5c1.021.046,1.976.049,2.8.032v1.7h4.687v-6.753h-4.687v3.26c-.782.027-1.757.029-2.8-.038v-3.222h-4.687v2.3a5.88,5.88,0,0,1-2.708-1.926Z",
    transform: "translate(-961.068 -453.558)",
    fill: "#d17918"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    id: "Path_72071",
    "data-name": "Path 72071",
    d: "M1014.866,462.678c0,5.634-11.921,10.219-26.573,10.219s-26.573-4.585-26.573-10.219,11.92-10.219,26.573-10.219,26.573,4.584,26.573,10.219m6.073,0c0-6.934-14.616-12.555-32.646-12.555s-32.645,5.621-32.645,12.555,14.616,12.555,32.645,12.555,32.646-5.622,32.646-12.555Z",
    transform: "translate(-955.648 -450.123)",
    fill: "#ffc022"
  })), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "Group_39754",
    "data-name": "Group 39754",
    transform: "translate(9.585 3.686)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72072",
    "data-name": "Path 72072",
    d: "M968.278,463.849c0-4.892,10.346-8.869,23.06-8.869s23.061,3.977,23.061,8.869-10.345,8.868-23.061,8.868S968.278,468.739,968.278,463.849Zm45.108,0c0-4.676-9.892-8.48-22.048-8.48s-22.048,3.8-22.048,8.48,9.891,8.478,22.048,8.478S1013.386,468.524,1013.386,463.849Z",
    transform: "translate(-968.278 -454.98)",
    fill: "#ffc022"
  }))), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    id: "Path_72073",
    "data-name": "Path 72073",
    d: "M990.753,462.145l-12.626,3.631V468.3l12.923-3.987a13.134,13.134,0,0,0,5.491,2.331c.194.042.389.077.584.115v2.251h4.687v-1.73c1.021.043,1.976.048,2.8.032v1.7h4.687v-6.753h-4.687v3.26c-.782.027-1.757.03-2.8-.038v-3.222h-4.687v2.3a5.887,5.887,0,0,1-2.708-1.927Z",
    transform: "translate(-961.068 -453.022)",
    fill: "#ffc022"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39766",
    "data-name": "Group 39766",
    transform: "translate(71.513 37.94)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39765",
    "data-name": "Group 39765"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39764",
    "data-name": "Group 39764"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39763",
    "data-name": "Group 39763"
  }, _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    id: "Path_72074",
    "data-name": "Path 72074",
    d: "M955.648,456.054c0,6.933,14.616,12.555,32.645,12.555s32.646-5.622,32.646-12.555v-5.931H955.648Z",
    transform: "translate(-955.648 -437.568)",
    fill: "#ff931e"
  })), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "Group_39760",
    "data-name": "Group 39760",
    transform: "translate(0 12.579)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72075",
    "data-name": "Path 72075",
    d: "M994.571,454.139v15.379c1.023.037,2.058.058,3.106.058V454.139Z",
    transform: "translate(-965.032 -451.116)",
    fill: "#d17918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72076",
    "data-name": "Path 72076",
    d: "M986.277,454.139v14.906c1.687.2,3.431.337,5.22.425V454.139Z",
    transform: "translate(-963.033 -451.116)",
    fill: "#d17918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72077",
    "data-name": "Path 72077",
    d: "M977.6,467.923V450.155H955.648v5.906C955.648,461.554,964.824,466.22,977.6,467.923Z",
    transform: "translate(-955.648 -450.155)",
    fill: "#d17918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72078",
    "data-name": "Path 72078",
    d: "M1013.988,454.139v14.614c.356-.052.713-.1,1.063-.161V454.139Z",
    transform: "translate(-969.714 -451.116)",
    fill: "#d17918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72079",
    "data-name": "Path 72079",
    d: "M1008.636,469.234q.535-.048,1.062-.1V454.139h-1.062Z",
    transform: "translate(-968.423 -451.116)",
    fill: "#d17918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72080",
    "data-name": "Path 72080",
    d: "M1001.852,454.139v15.4c.522-.014,1.039-.033,1.553-.057V454.139Z",
    transform: "translate(-966.788 -451.116)",
    fill: "#d17918"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39762",
    "data-name": "Group 39762"
  }, _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    id: "Path_72081",
    "data-name": "Path 72081",
    d: "M988.293,458.69c-18.028,0-32.645-5.622-32.645-12.555s14.616-12.554,32.645-12.554,32.646,5.62,32.646,12.554S1006.323,458.69,988.293,458.69Z",
    transform: "translate(-955.648 -433.58)",
    fill: "#ff931e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_72082",
    "data-name": "Path 72082",
    d: "M1006.686,456.522c-.926.03-1.859.049-2.807.049-18.029,0-32.645-5.62-32.645-12.555,0-4.311,5.649-8.11,14.251-10.372-16.713.547-29.838,5.935-29.838,12.505,0,6.933,14.616,12.555,32.645,12.555A73.684,73.684,0,0,0,1006.686,456.522Z",
    transform: "translate(-955.648 -433.596)",
    opacity: 0.4,
    fill: "url(#linear-gradient-13)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    id: "Path_72083",
    "data-name": "Path 72083",
    d: "M1020.921,446.771c-.537-6.753-14.93-12.165-32.62-12.165s-32.083,5.412-32.619,12.165c.536,6.752,14.93,12.166,32.619,12.166S1020.384,453.523,1020.921,446.771ZM988.3,457.381c-14.653,0-26.573-4.584-26.573-10.219s11.92-10.219,26.573-10.219,26.573,4.584,26.573,10.219S1002.953,457.381,988.3,457.381Z",
    transform: "translate(-955.656 -433.827)",
    fill: "#d17918"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    id: "Path_72084",
    "data-name": "Path 72084",
    d: "M990.753,447.827l-12.626,3.629v2.522l12.923-3.984a13.134,13.134,0,0,0,5.491,2.331c.194.042.389.077.584.113v2.251h4.687v-1.73c1.021.046,1.976.05,2.8.033v1.7h4.687v-6.753h-4.687v3.26c-.782.027-1.757.028-2.8-.039v-3.222h-4.687v2.3a5.88,5.88,0,0,1-2.708-1.926Z",
    transform: "translate(-961.068 -437.015)",
    fill: "#d17918"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    id: "Path_72085",
    "data-name": "Path 72085",
    d: "M1014.866,446.134c0,5.634-11.921,10.219-26.573,10.219s-26.573-4.585-26.573-10.219,11.92-10.219,26.573-10.219,26.573,4.584,26.573,10.219m6.073,0c0-6.934-14.616-12.554-32.646-12.554s-32.645,5.62-32.645,12.554,14.616,12.555,32.645,12.555,32.646-5.622,32.646-12.555Z",
    transform: "translate(-955.648 -433.58)",
    fill: "#ffc022"
  })), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "Group_39761",
    "data-name": "Group 39761",
    transform: "translate(9.585 3.686)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72086",
    "data-name": "Path 72086",
    d: "M968.278,447.306c0-4.891,10.346-8.868,23.06-8.868s23.061,3.977,23.061,8.868-10.345,8.869-23.061,8.869S968.278,452.2,968.278,447.306Zm45.108,0c0-4.676-9.892-8.48-22.048-8.48s-22.048,3.8-22.048,8.48,9.891,8.478,22.048,8.478S1013.386,451.98,1013.386,447.306Z",
    transform: "translate(-968.278 -438.437)",
    fill: "#ffc022"
  }))), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    id: "Path_72087",
    "data-name": "Path 72087",
    d: "M990.753,445.6l-12.626,3.63v2.522l12.923-3.987a13.124,13.124,0,0,0,5.491,2.331c.194.042.389.077.584.115v2.251h4.687v-1.73c1.021.043,1.976.048,2.8.032v1.7h4.687V445.71h-4.687v3.261c-.782.027-1.757.03-2.8-.038V445.71h-4.687v2.3a5.886,5.886,0,0,1-2.708-1.926Z",
    transform: "translate(-961.068 -436.478)",
    fill: "#ffc022"
  }))))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_72088",
    "data-name": "Path 72088",
    d: "M904.357,453.955c-4.894-1.2-10.955,5.26-15.554,15.6l.011.046c.039.136.084.272.134.407.021.057.04.115.063.171a5.958,5.958,0,0,0,.26.558c.017.032.037.063.055.095.084.153.175.306.275.457.043.066.09.131.136.2.011.017.021.033.033.049-.06.083-.121.167-.175.252-.07.106-.131.214-.194.322-.052.09-.106.18-.153.27-.058.112-.108.226-.158.339-.039.087-.081.175-.115.263-.047.121-.083.244-.121.366-.025.083-.055.164-.077.247-.035.136-.058.274-.081.411-.013.07-.031.14-.039.21a4.97,4.97,0,0,0-.042.629v5.931a4.937,4.937,0,0,0,.039.59c.008.061.019.121.029.182q.032.2.08.408c.016.068.033.134.052.2.039.136.084.272.134.407.021.057.04.115.063.172a6.144,6.144,0,0,0,.26.558c.017.033.038.064.055.1q.126.229.274.455c.043.066.09.132.136.2l.033.048c-.059.083-.12.166-.175.25-.071.108-.133.218-.2.327-.051.089-.1.177-.15.266-.059.114-.109.229-.16.344-.038.086-.08.172-.114.259-.047.122-.084.246-.121.37-.026.081-.056.162-.077.244-.036.137-.058.275-.082.414-.012.07-.03.138-.039.209a4.837,4.837,0,0,0-.042.629v5.931a4.937,4.937,0,0,0,.039.59c.008.061.019.121.029.182.021.137.048.272.08.408q.024.1.052.2c.039.136.085.272.134.408.021.057.04.114.063.171a6.157,6.157,0,0,0,.26.559c.017.031.037.062.055.094.084.153.176.307.276.458.042.065.089.129.134.194q.124.178.262.354c.054.069.108.138.165.206.1.12.2.238.312.355.055.06.107.12.164.18.161.166.33.332.509.5.064.058.134.116.2.175.125.11.251.219.384.327.091.074.186.147.281.221q.175.135.359.269c.1.077.211.153.319.228.125.086.253.172.383.256.112.074.222.149.339.222q.333.209.688.412c.144.083.294.165.444.246.118.064.234.128.354.191.162.086.327.169.495.253.112.056.225.112.338.166.181.087.361.173.547.258.088.04.179.079.268.119q1.038.462,2.189.884l.234.086c.247.09.5.177.754.263l.218.073c1.08.357,2.227.685,3.423.988a76.451,76.451,0,0,0,5.392-15.167C913.06,471.145,911.091,455.609,904.357,453.955Z",
    transform: "translate(-867.973 -400.517)",
    fill: "#ccc",
    opacity: 0.6,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_39773",
    "data-name": "Group 39773",
    transform: "translate(0 47.239)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39772",
    "data-name": "Group 39772"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39771",
    "data-name": "Group 39771"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39770",
    "data-name": "Group 39770"
  }, _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    id: "Path_72089",
    "data-name": "Path 72089",
    d: "M873.165,509.183c6.445,2.554,17.056-8.963,23.7-25.724s6.8-32.421.357-34.975l-5.514-2.184L867.651,507Z",
    transform: "translate(-862.919 -445.945)",
    fill: "#ff931e"
  })), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "Group_39767",
    "data-name": "Group 39767",
    transform: "translate(4.755 20.028)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72090",
    "data-name": "Path 72090",
    d: "M885.725,490.659l14.3,5.666q.616-1.406,1.2-2.866l-14.351-5.687Z",
    transform: "translate(-872.031 -475.972)",
    fill: "#d17918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72091",
    "data-name": "Path 72091",
    d: "M882.67,497.745l13.857,5.491q1.2-2.244,2.318-4.695l-14.253-5.648Z",
    transform: "translate(-871.295 -477.207)",
    fill: "#d17918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72092",
    "data-name": "Path 72092",
    d: "M892.286,505.948,875.769,499.4l-8.088,20.408,5.491,2.176C878.278,524.009,886,517.2,892.286,505.948Z",
    transform: "translate(-867.681 -478.776)",
    fill: "#d17918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72093",
    "data-name": "Path 72093",
    d: "M892.879,473.211l13.585,5.384c.083-.349.166-.7.243-1.047l-13.437-5.324Z",
    transform: "translate(-873.756 -472.223)",
    fill: "#d17918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72094",
    "data-name": "Path 72094",
    d: "M904.939,483.749q.153-.516.294-1.027L891.3,477.2l-.391.987Z",
    transform: "translate(-873.281 -473.423)",
    fill: "#d17918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72095",
    "data-name": "Path 72095",
    d: "M888.408,484.348l14.315,5.673c.179-.49.351-.977.519-1.465L888.979,482.9Z",
    transform: "translate(-872.678 -474.798)",
    fill: "#d17918"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39769",
    "data-name": "Group 39769"
  }, _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    id: "Path_72096",
    "data-name": "Path 72096",
    d: "M889.846,481.162c-6.642,16.76-17.251,28.277-23.7,25.724s-6.287-18.214.355-34.974,17.253-28.28,23.7-25.724S896.489,464.4,889.846,481.162Z",
    transform: "translate(-861.416 -445.832)",
    fill: "#ff931e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_72097",
    "data-name": "Path 72097",
    d: "M894.594,468.794c-.313.871-.64,1.747-.989,2.628-6.642,16.76-17.252,28.277-23.7,25.724-4.007-1.588-5.46-8.24-4.392-17.07-5.649,15.738-5.475,29.925.633,32.346,6.447,2.554,17.056-8.963,23.7-25.724A73.655,73.655,0,0,0,894.594,468.794Z",
    transform: "translate(-861.416 -451.368)",
    opacity: 0.4,
    fill: "url(#linear-gradient-14)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    id: "Path_72098",
    "data-name": "Path 72098",
    d: "M890.786,446.448c-6.476-1.988-16.811,9.4-23.328,25.844s-6.787,31.82-.707,34.807c6.475,1.988,16.81-9.4,23.326-25.843S896.864,449.436,890.786,446.448Zm-2.156,34.234c-5.4,13.622-14.051,23.016-19.29,20.939s-5.109-14.846.289-28.468,14.052-23.016,19.291-20.94S894.028,467.06,888.63,480.683Z",
    transform: "translate(-861.647 -445.927)",
    fill: "#d17918"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    id: "Path_72099",
    "data-name": "Path 72099",
    d: "M879.522,483.606l-1.279,13.075,2.345.93,1.057-13.482a13.143,13.143,0,0,0,4.189-4.245c.111-.165.216-.332.321-.5l2.092.829,1.727-4.357-1.607-.637c.419-.933.774-1.819,1.062-2.592l1.578.625,1.726-4.358-6.277-2.487-1.726,4.358,3.03,1.2c-.263.738-.621,1.644-1.067,2.59l-3-1.186-1.727,4.357,2.138.847a5.889,5.889,0,0,1-2.788,1.808Z",
    transform: "translate(-865.473 -450.792)",
    fill: "#d17918"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    id: "Path_72100",
    "data-name": "Path 72100",
    d: "M887.965,451.833c5.239,2.076,5.109,14.847-.29,28.469s-14.052,23.014-19.29,20.938-5.109-14.846.289-28.468,14.051-23.016,19.291-20.94m2.237-5.646c-6.446-2.555-17.056,8.963-23.7,25.724s-6.8,32.419-.355,34.974,17.056-8.963,23.7-25.724,6.8-32.42.356-34.975Z",
    transform: "translate(-861.416 -445.832)",
    fill: "#ffc022"
  })), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "Group_39768",
    "data-name": "Group 39768",
    transform: "translate(4.926 9.016)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72101",
    "data-name": "Path 72101",
    d: "M871.244,500.839c-4.547-1.8-4.433-12.886.251-24.7s12.193-19.974,16.741-18.172,4.433,12.884-.251,24.706S875.79,502.642,871.244,500.839ZM887.862,458.9c-4.347-1.722-11.527,6.072-16.006,17.373s-4.586,21.9-.239,23.622,11.527-6.072,16.005-17.373S892.208,460.626,887.862,458.9Z",
    transform: "translate(-867.906 -457.713)",
    fill: "#ffc022"
  }))), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    id: "Path_72102",
    "data-name": "Path 72102",
    d: "M877.454,482.787l-1.277,13.075,2.344.929,1.055-13.483a13.132,13.132,0,0,0,4.19-4.246c.11-.164.214-.332.322-.5l2.092.829,1.727-4.357L886.3,474.4c.417-.934.772-1.82,1.061-2.592l1.578.625,1.726-4.357-6.279-2.488-1.726,4.357,3.031,1.2c-.263.738-.62,1.645-1.068,2.59l-3-1.188L879.9,476.9l2.139.847a5.886,5.886,0,0,1-2.79,1.808Z",
    transform: "translate(-864.975 -450.595)",
    fill: "#ffc022"
  }))))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_72103",
    "data-name": "Path 72103",
    d: "M1009.448,523.581c11.726-1.9,19.954-6.369,19.954-11.57v-5.932a5.7,5.7,0,0,0-1.157-3.312,5.692,5.692,0,0,0,1.157-3.311v-5.931a5.7,5.7,0,0,0-1.157-3.313,5.692,5.692,0,0,0,1.157-3.311v-5.931a5.7,5.7,0,0,0-1.157-3.313,5.692,5.692,0,0,0,1.157-3.311v-.086c-6.7-2.349-19.194,7.744-28.743,23.512-5.881,9.712-9.333,19.416-9.91,26.574.6.042,1.21.081,1.824.112h0c1.37.068,2.763.106,4.181.106,1.339,0,2.656-.035,3.953-.095h.02a77.572,77.572,0,0,0,8.1-.8C1009.038,523.643,1009.246,523.614,1009.448,523.581Z",
    transform: "translate(-892.598 -405.366)",
    fill: "#ccc",
    opacity: 0.6,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_39780",
    "data-name": "Group 39780",
    transform: "translate(125.777 66.73)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39779",
    "data-name": "Group 39779"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39778",
    "data-name": "Group 39778"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39777",
    "data-name": "Group 39777"
  }, _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    id: "Path_72104",
    "data-name": "Path 72104",
    d: "M1055.937,534.867c-6.445,2.555-17.056-8.963-23.7-25.723s-6.8-32.422-.356-34.975l5.513-2.184,24.053,60.7Z",
    transform: "translate(-1027.152 -471.629)",
    fill: "#ff931e"
  })), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "Group_39774",
    "data-name": "Group 39774",
    transform: "translate(1.326 20.028)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72105",
    "data-name": "Path 72105",
    d: "M1049.35,516.342l-14.3,5.666q-.616-1.4-1.2-2.866l14.351-5.687Z",
    transform: "translate(-1030.094 -501.656)",
    fill: "#d17918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72106",
    "data-name": "Path 72106",
    d: "M1052.191,523.429l-13.858,5.491q-1.2-2.244-2.318-4.7l14.253-5.648Z",
    transform: "translate(-1030.615 -502.891)",
    fill: "#d17918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72107",
    "data-name": "Path 72107",
    d: "M1039.9,531.632l16.518-6.546,8.087,20.408-5.491,2.176C1053.9,549.693,1046.186,542.881,1039.9,531.632Z",
    transform: "translate(-1031.55 -504.46)",
    fill: "#d17918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72108",
    "data-name": "Path 72108",
    d: "M1042.728,498.9l-13.586,5.383c-.083-.349-.166-.7-.243-1.047l13.437-5.324Z",
    transform: "translate(-1028.899 -497.907)",
    fill: "#d17918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72109",
    "data-name": "Path 72109",
    d: "M1030.508,509.432c-.1-.344-.2-.685-.293-1.026l13.935-5.523.391.987Z",
    transform: "translate(-1029.216 -499.107)",
    fill: "#d17918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72110",
    "data-name": "Path 72110",
    d: "M1046.879,510.032l-14.316,5.672q-.269-.734-.518-1.465l14.262-5.651Z",
    transform: "translate(-1029.658 -500.482)",
    fill: "#d17918"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39776",
    "data-name": "Group 39776",
    transform: "translate(5.513)"
  }, _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    id: "Path_72111",
    "data-name": "Path 72111",
    d: "M1039.5,506.846c6.642,16.76,17.251,28.277,23.7,25.723s6.287-18.214-.354-34.974-17.253-28.279-23.7-25.724S1032.863,490.084,1039.5,506.846Z",
    transform: "translate(-1034.417 -471.516)",
    fill: "#ff931e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_72112",
    "data-name": "Path 72112",
    d: "M1034.865,494.477c.313.872.64,1.748.989,2.629,6.642,16.76,17.252,28.277,23.7,25.723,4.007-1.588,5.46-8.24,4.393-17.07,5.65,15.739,5.475,29.926-.634,32.346-6.446,2.554-17.056-8.963-23.7-25.723A73.652,73.652,0,0,1,1034.865,494.477Z",
    transform: "translate(-1034.525 -477.052)",
    opacity: 0.4,
    fill: "url(#linear-gradient-15)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    id: "Path_72113",
    "data-name": "Path 72113",
    d: "M1039.506,506.94c6.517,16.445,16.851,27.831,23.326,25.843,6.08-2.988,5.81-18.362-.706-34.808s-16.852-27.83-23.328-25.843C1032.719,475.12,1032.988,490.494,1039.506,506.94Zm1.157-29.043c5.239-2.076,13.892,7.318,19.29,20.94s5.529,26.393.29,28.469-13.892-7.317-19.291-20.939S1035.425,479.974,1040.663,477.9Z",
    transform: "translate(-1034.418 -471.611)",
    fill: "#d17918"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    id: "Path_72114",
    "data-name": "Path 72114",
    d: "M1055.875,509.288l1.278,13.076-2.345.93-1.057-13.482a13.16,13.16,0,0,1-4.189-4.246c-.111-.165-.216-.332-.321-.5l-2.091.829-1.727-4.357,1.608-.637c-.42-.933-.776-1.82-1.063-2.592l-1.577.625-1.727-4.358,6.277-2.488,1.727,4.358-3.031,1.2c.263.737.621,1.644,1.067,2.59l3-1.187,1.727,4.357-2.139.848a5.884,5.884,0,0,0,2.789,1.808Z",
    transform: "translate(-1036.405 -476.476)",
    fill: "#d17918"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    id: "Path_72115",
    "data-name": "Path 72115",
    d: "M1041.385,477.516c5.24-2.076,13.893,7.318,19.291,20.94s5.528,26.392.289,28.469-13.892-7.317-19.29-20.939-5.529-26.393-.291-28.469m-2.237-5.645c-6.446,2.554-6.286,18.213.356,34.975s17.251,28.277,23.7,25.723,6.287-18.214-.354-34.974-17.253-28.279-23.7-25.724Z",
    transform: "translate(-1034.417 -471.516)",
    fill: "#ffc022"
  })), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "Group_39775",
    "data-name": "Group 39775",
    transform: "translate(4.926 9.016)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72116",
    "data-name": "Path 72116",
    d: "M1044.5,508.353c-4.685-11.822-4.8-22.905-.252-24.707s12.056,6.35,16.741,18.172,4.8,22.9.25,24.7S1049.18,520.172,1044.5,508.353Zm.361-.144c4.478,11.3,11.659,19.1,16.005,17.373s4.239-12.319-.239-23.622-11.659-19.095-16.006-17.374S1040.379,496.906,1044.858,508.208Z",
    transform: "translate(-1040.908 -483.396)",
    fill: "#ffc022"
  }))), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    id: "Path_72117",
    "data-name": "Path 72117",
    d: "M1057.942,508.47l1.277,13.076-2.344.928-1.054-13.482a13.127,13.127,0,0,1-4.191-4.246c-.109-.165-.214-.333-.322-.5l-2.092.829-1.727-4.357,1.607-.637c-.417-.933-.772-1.819-1.061-2.592l-1.579.626-1.727-4.358,6.279-2.488,1.726,4.357-3.031,1.2c.264.738.62,1.645,1.068,2.59l3-1.187,1.727,4.358-2.139.847a5.875,5.875,0,0,0,2.79,1.808Z",
    transform: "translate(-1036.903 -476.279)",
    fill: "#ffc022"
  })))))))), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    id: "Path_72118",
    "data-name": "Path 72118",
    d: "M903.82,463.327l-1.331-3.374-1.331,3.374-3.374,1.331,3.374,1.331,1.331,3.374,1.331-3.374,3.374-1.331Z",
    transform: "translate(-870.184 -401.998)",
    fill: "#fff"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    id: "Path_72119",
    "data-name": "Path 72119",
    d: "M1030.051,458.619l-1.331-3.374-1.331,3.374-3.374,1.331,3.374,1.331,1.331,3.374,1.331-3.374,3.374-1.331Z",
    transform: "translate(-900.618 -400.863)",
    fill: "#fff"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    id: "Path_72120",
    "data-name": "Path 72120",
    d: "M1071.428,409.041l-1.331-3.374-1.331,3.374-3.374,1.331,3.374,1.331,1.331,3.374,1.331-3.374,3.374-1.331Z",
    transform: "translate(-910.594 -388.91)",
    fill: "#fff"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    id: "Path_72121",
    "data-name": "Path 72121",
    d: "M965.431,490.879,964.1,487.5l-1.331,3.374-3.374,1.331,3.374,1.331,1.331,3.374,1.331-3.374,3.374-1.331Z",
    transform: "translate(-885.038 -408.641)",
    fill: "#fff"
  }))), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    id: "Path_72122",
    "data-name": "Path 72122",
    d: "M895.85,277.754s-18.061,13.191-23.723,23.257c0,0,24.135-17.89,37.032-23.257Z",
    transform: "translate(-777.308 -210.44)",
    fill: "#dab873"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    id: "Path_72123",
    "data-name": "Path 72123",
    d: "M910.531,277.754a51.183,51.183,0,0,1,20.726,23.257s-.883-13.4-8.132-23.257Z",
    transform: "translate(-786.567 -210.44)",
    fill: "#dab873"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    id: "Path_72124",
    "data-name": "Path 72124",
    d: "M946.954,321.441s12.219,22.928,18.852,47.94C965.806,369.382,967.244,340.99,946.954,321.441Z",
    transform: "translate(-795.348 -220.973)",
    fill: "#dab873"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    id: "Path_72125",
    "data-name": "Path 72125",
    d: "M968.278,325.272S980.5,348.2,987.13,373.213C987.13,373.213,988.568,344.821,968.278,325.272Z",
    transform: "translate(-800.49 -221.897)",
    fill: "#e8c47b"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    id: "Path_72126",
    "data-name": "Path 72126",
    d: "M943.015,335.5s20.508-3.349,39.144,1.462C982.159,336.96,963.487,327.276,943.015,335.5Z",
    transform: "translate(-794.399 -223.564)",
    fill: "#e8c47b"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    id: "Path_72127",
    "data-name": "Path 72127",
    d: "M948.917,350.048s20.507-3.349,39.143,1.462C988.06,351.51,969.388,341.827,948.917,350.048Z",
    transform: "translate(-795.822 -227.072)",
    fill: "#e8c47b"
  })), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "Group_39783",
    "data-name": "Group 39783",
    transform: "translate(148.616 108.705)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72128",
    "data-name": "Path 72128",
    d: "M948.917,350.064a113.027,113.027,0,0,1,16.3-1.132q-.445-1.054-.916-2.128A46.06,46.06,0,0,0,948.917,350.064Z",
    transform: "translate(-944.438 -335.793)",
    fill: "#dab873"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72129",
    "data-name": "Path 72129",
    d: "M958.7,334.4q-.524-1.046-1.071-2.1a45.993,45.993,0,0,0-14.612,3.228A112.138,112.138,0,0,1,958.7,334.4Z",
    transform: "translate(-943.015 -332.295)",
    fill: "#dab873"
  }))), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    id: "Path_72130",
    "data-name": "Path 72130",
    d: "M876.075,203.026l26.149,48.913v-52.16q-.75.312-1.513.618l-.273.109c-.509.2-1.021.405-1.536.6l-.06.024q-.793.3-1.593.585l-.327.114q-.625.217-1.251.422c-.142.046-.283.092-.424.136q-.722.229-1.442.433c-.042.012-.085.026-.128.037-.513.143-1.024.272-1.533.392-.14.033-.277.061-.416.093q-.578.127-1.149.231c-.147.027-.294.055-.441.079-.5.083-1,.157-1.5.208A41.954,41.954,0,0,1,876.075,203.026Z",
    transform: "translate(-778.26 -191.641)",
    fill: "#dab873"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    id: "Path_72131",
    "data-name": "Path 72131",
    d: "M866.519,201.683c-.546-.153-1.154-.339-1.8-.543l21.7,33.254-15.872-31.661C869.173,202.4,867.83,202.048,866.519,201.683Z",
    transform: "translate(-775.52 -191.969)",
    fill: "#dab873"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    id: "Path_72132",
    "data-name": "Path 72132",
    d: "M999.7,197.482c4.043-3.089,4.871-7.584-2.342-8.321-12.641-1.292-21.019,9.609-33.6,10.5l-28.943,56.711h11.234Z",
    transform: "translate(-792.422 -189.055)",
    fill: "#dab873"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    id: "Path_72133",
    "data-name": "Path 72133",
    d: "M939.418,244.264l21.42-42.793c-4.394-.477-7.273-2.477-10.09-4.587Z",
    transform: "translate(-793.531 -190.943)",
    fill: "#dab873"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39788",
    "data-name": "Group 39788",
    transform: "translate(849.809 243.754)"
  }, _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "Group_39786",
    "data-name": "Group 39786"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72136",
    "data-name": "Path 72136",
    d: "M944.091,271.7a3.44,3.44,0,0,1-.735-.08c-19.787-4.369-56.374.011-56.741.055a3.933,3.933,0,0,1-4.181-3.785,4.177,4.177,0,0,1,3.363-4.705c1.546-.189,38.1-4.566,59.02.055a4.274,4.274,0,0,1,2.993,5.012A3.94,3.94,0,0,1,944.091,271.7Z",
    transform: "translate(-882.412 -261.131)",
    fill: "#ff931e"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    id: "Group_39787",
    "data-name": "Group 39787",
    transform: "translate(2.414 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72137",
    "data-name": "Path 72137",
    d: "M918.723,261.332q-.949.032-1.881.071a27.466,27.466,0,0,0-3.508,8.733q.788-.042,1.593-.081A25.92,25.92,0,0,1,918.723,261.332Z",
    transform: "translate(-892.281 -261.18)",
    fill: "#bf6e17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72138",
    "data-name": "Path 72138",
    d: "M904.6,262.07q-.963.066-1.882.134a27.994,27.994,0,0,0-3.271,8.839q.766-.065,1.582-.131A26.46,26.46,0,0,1,904.6,262.07Z",
    transform: "translate(-888.934 -261.358)",
    fill: "#bf6e17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72139",
    "data-name": "Path 72139",
    d: "M911.693,261.637q-.956.05-1.884.1a27.752,27.752,0,0,0-3.407,8.792q.776-.054,1.58-.106A26.134,26.134,0,0,1,911.693,261.637Z",
    transform: "translate(-890.61 -261.254)",
    fill: "#bf6e17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72140",
    "data-name": "Path 72140",
    d: "M897.452,262.624q-.978.082-1.871.164a28.192,28.192,0,0,0-3.11,8.879q.726-.074,1.584-.156A26.806,26.806,0,0,1,897.452,262.624Z",
    transform: "translate(-887.251 -261.492)",
    fill: "#bf6e17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72141",
    "data-name": "Path 72141",
    d: "M888.422,263.5a28.43,28.43,0,0,0-2.829,8.431,3.4,3.4,0,0,0,1.5.289,27.015,27.015,0,0,1,3.195-8.918C889.572,263.374,888.948,263.441,888.422,263.5Z",
    transform: "translate(-885.593 -261.655)",
    fill: "#bf6e17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72142",
    "data-name": "Path 72142",
    d: "M958.944,263.016q-.8-.134-1.623-.255a28.046,28.046,0,0,0-3,8.2c.509.062,1.015.128,1.511.2A26.689,26.689,0,0,1,958.944,263.016Z",
    transform: "translate(-902.163 -261.525)",
    fill: "#bf6e17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72143",
    "data-name": "Path 72143",
    d: "M963.761,263.908l-.092-.02a28.533,28.533,0,0,0-2.684,8.129c.445.087.885.176,1.315.271.058.013.116.009.175.019a27.242,27.242,0,0,1,2.6-7.8A3.537,3.537,0,0,0,963.761,263.908Z",
    transform: "translate(-903.77 -261.796)",
    fill: "#bf6e17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72144",
    "data-name": "Path 72144",
    d: "M945.991,261.606c-.582-.041-1.166-.077-1.754-.111a27.508,27.508,0,0,0-3.4,8.395q.78.027,1.556.063A26.009,26.009,0,0,1,945.991,261.606Z",
    transform: "translate(-898.911 -261.22)",
    fill: "#bf6e17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72145",
    "data-name": "Path 72145",
    d: "M952.532,262.167c-.559-.062-1.121-.122-1.69-.177a27.708,27.708,0,0,0-3.241,8.293c.517.037,1.028.079,1.537.122A26.339,26.339,0,0,1,952.532,262.167Z",
    transform: "translate(-900.543 -261.339)",
    fill: "#bf6e17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72146",
    "data-name": "Path 72146",
    d: "M939.327,261.276q-.9-.033-1.8-.055a27.363,27.363,0,0,0-3.514,8.492q.786.006,1.571.018A25.849,25.849,0,0,1,939.327,261.276Z",
    transform: "translate(-897.267 -261.153)",
    fill: "#bf6e17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72147",
    "data-name": "Path 72147",
    d: "M930.716,261.132a27.317,27.317,0,0,0-3.562,8.584q.789-.013,1.58-.021a25.792,25.792,0,0,1,3.819-8.554Q931.634,261.133,930.716,261.132Z",
    transform: "translate(-895.613 -261.132)",
    fill: "#bf6e17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72148",
    "data-name": "Path 72148",
    d: "M925.68,261.163q-.935.013-1.862.033a27.347,27.347,0,0,0-3.558,8.664q.789-.028,1.587-.052A25.854,25.854,0,0,1,925.68,261.163Z",
    transform: "translate(-893.951 -261.139)",
    fill: "#bf6e17"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_72149",
    "data-name": "Path 72149",
    d: "M944.091,269.487a3.391,3.391,0,0,1-.735-.08c-19.787-4.369-56.374.011-56.741.055a3.741,3.741,0,0,1-3.838-2.424,4.716,4.716,0,0,0-.343,2.279,3.933,3.933,0,0,0,4.181,3.785c.367-.044,36.954-4.424,56.741-.055a3.44,3.44,0,0,0,.735.08,3.94,3.94,0,0,0,3.719-3.448,4.7,4.7,0,0,0-.305-2.644A3.785,3.785,0,0,1,944.091,269.487Z",
    transform: "translate(-882.413 -262.555)",
    fill: "#b3b3b3",
    opacity: 0.8,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_39791",
    "data-name": "Group 39791",
    transform: "translate(849.809 252.332)"
  }, _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    id: "Group_39789",
    "data-name": "Group 39789"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72150",
    "data-name": "Path 72150",
    d: "M944.091,283.007a3.4,3.4,0,0,1-.735-.081c-19.787-4.368-56.374.011-56.741.055a3.933,3.933,0,0,1-4.181-3.785,4.177,4.177,0,0,1,3.363-4.7c1.546-.189,38.1-4.566,59.02.055a4.275,4.275,0,0,1,2.993,5.013A3.94,3.94,0,0,1,944.091,283.007Z",
    transform: "translate(-882.412 -272.435)",
    fill: "#ff931e"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    id: "Group_39790",
    "data-name": "Group 39790",
    transform: "translate(2.414 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72151",
    "data-name": "Path 72151",
    d: "M918.723,272.635q-.949.033-1.881.071a27.458,27.458,0,0,0-3.508,8.733q.788-.042,1.593-.081A25.933,25.933,0,0,1,918.723,272.635Z",
    transform: "translate(-892.281 -272.484)",
    fill: "#bf6e17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72152",
    "data-name": "Path 72152",
    d: "M904.6,273.374q-.963.066-1.882.134a27.987,27.987,0,0,0-3.271,8.839q.766-.065,1.582-.131A26.46,26.46,0,0,1,904.6,273.374Z",
    transform: "translate(-888.934 -272.662)",
    fill: "#bf6e17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72153",
    "data-name": "Path 72153",
    d: "M911.693,272.941q-.956.05-1.884.1a27.744,27.744,0,0,0-3.407,8.792q.776-.055,1.58-.106A26.126,26.126,0,0,1,911.693,272.941Z",
    transform: "translate(-890.61 -272.558)",
    fill: "#bf6e17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72154",
    "data-name": "Path 72154",
    d: "M897.452,273.927q-.978.083-1.871.165a28.179,28.179,0,0,0-3.11,8.878q.726-.073,1.584-.156A26.818,26.818,0,0,1,897.452,273.927Z",
    transform: "translate(-887.251 -272.795)",
    fill: "#bf6e17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72155",
    "data-name": "Path 72155",
    d: "M888.422,274.8a28.435,28.435,0,0,0-2.829,8.432,3.4,3.4,0,0,0,1.5.289,27.008,27.008,0,0,1,3.195-8.918C889.572,274.678,888.948,274.745,888.422,274.8Z",
    transform: "translate(-885.593 -272.959)",
    fill: "#bf6e17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72156",
    "data-name": "Path 72156",
    d: "M958.944,274.32q-.8-.135-1.623-.255a28.037,28.037,0,0,0-3,8.2c.509.062,1.015.127,1.511.2A26.68,26.68,0,0,1,958.944,274.32Z",
    transform: "translate(-902.163 -272.829)",
    fill: "#bf6e17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72157",
    "data-name": "Path 72157",
    d: "M963.761,275.211l-.092-.019a28.535,28.535,0,0,0-2.684,8.128c.445.087.885.176,1.315.271.058.013.116.01.175.02a27.257,27.257,0,0,1,2.6-7.8A3.56,3.56,0,0,0,963.761,275.211Z",
    transform: "translate(-903.77 -273.1)",
    fill: "#bf6e17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72158",
    "data-name": "Path 72158",
    d: "M945.991,272.909q-.873-.06-1.754-.11a27.51,27.51,0,0,0-3.4,8.394q.78.028,1.556.064A26.015,26.015,0,0,1,945.991,272.909Z",
    transform: "translate(-898.911 -272.524)",
    fill: "#bf6e17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72159",
    "data-name": "Path 72159",
    d: "M952.532,273.471c-.559-.063-1.121-.122-1.69-.177a27.707,27.707,0,0,0-3.241,8.293q.775.056,1.537.122A26.323,26.323,0,0,1,952.532,273.471Z",
    transform: "translate(-900.543 -272.643)",
    fill: "#bf6e17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72160",
    "data-name": "Path 72160",
    d: "M939.327,272.58q-.9-.033-1.8-.056a27.371,27.371,0,0,0-3.514,8.492q.786.007,1.571.019A25.85,25.85,0,0,1,939.327,272.58Z",
    transform: "translate(-897.267 -272.457)",
    fill: "#bf6e17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72161",
    "data-name": "Path 72161",
    d: "M930.716,272.436a27.3,27.3,0,0,0-3.562,8.584q.789-.014,1.58-.021a25.786,25.786,0,0,1,3.819-8.554Q931.634,272.436,930.716,272.436Z",
    transform: "translate(-895.613 -272.436)",
    fill: "#bf6e17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72162",
    "data-name": "Path 72162",
    d: "M925.68,272.466q-.935.014-1.862.033a27.349,27.349,0,0,0-3.558,8.664q.789-.028,1.587-.052A25.852,25.852,0,0,1,925.68,272.466Z",
    transform: "translate(-893.951 -272.443)",
    fill: "#bf6e17"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_72163",
    "data-name": "Path 72163",
    d: "M944.091,280.791a3.4,3.4,0,0,1-.735-.081c-19.787-4.368-56.374.011-56.741.055a3.742,3.742,0,0,1-3.838-2.425,4.717,4.717,0,0,0-.343,2.279,3.933,3.933,0,0,0,4.181,3.785c.367-.044,36.954-4.424,56.741-.055a3.4,3.4,0,0,0,.735.081,3.94,3.94,0,0,0,3.719-3.448,4.7,4.7,0,0,0-.305-2.644A3.785,3.785,0,0,1,944.091,280.791Z",
    transform: "translate(-882.413 -273.858)",
    fill: "#b3b3b3",
    opacity: 0.8,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferImg);
export default __webpack_public_path__ + "static/media/refer_img.39300c3128cb3ed9d1e2fc24898cf23e.svg";
export { ForwardRef as ReactComponent };